const basicLightbox = {
  _toElement: function (e, t = !1) {
    const n = document.createElement("div");
    return (n.innerHTML = e.trim()), !0 === t ? n.children : n.firstChild;
  },
  _validateOptions: function (e = {}) {
    return (
      null == (e = Object.assign({}, e)).closable && (e.closable = !0),
      null == e.className && (e.className = ""),
      null == e.onShow && (e.onShow = () => {}),
      null == e.onClose && (e.onClose = () => {}),
      null == e.trigger && (e.trigger = !1),
      null == e.focus && (e.focus = !1),
      e
    );
  },
  _validateContent: function (e) {
    const t = "string" == typeof e,
      n = e instanceof HTMLElement == !0;
    if (!1 === t && !1 === n)
      throw new Error("Content must be a DOM element/node or string");
    return !0 === t
      ? Array.from(this._toElement(e, !0))
      : "TEMPLATE" === e.tagName
      ? [e.content.cloneNode(!0)]
      : Array.from(e.children);
  },
  _containsTag: function (e, t) {
    const n = e.children;
    return 1 === n.length && n[0].tagName === t;
  },
  _render: function (e, t) {
    const n = this._toElement(
        `\n      <div class="basicLightbox ${t.className}">\n        <div class="basicLightbox__placeholder" role="dialog"></div>\n      </div>\n    `
      ),
      i = n.querySelector(".basicLightbox__placeholder");
    e.forEach((e) => i.appendChild(e));
    const o = this._containsTag(i, "IMG"),
      s = this._containsTag(i, "VIDEO"),
      l = this._containsTag(i, "IFRAME");
    return (
      !0 === o && n.classList.add("basicLightbox--img"),
      !0 === s && n.classList.add("basicLightbox--video"),
      !0 === l && n.classList.add("basicLightbox--iframe"),
      n
    );
  },
  _show: function (e, t) {
    return (
      document.body.appendChild(e),
      setTimeout(() => {
        requestAnimationFrame(
          () => (e.classList.add("basicLightbox--visible"), t())
        );
      }, 10),
      !0
    );
  },
  _close: function (e, t) {
    return (
      e.classList.remove("basicLightbox--visible"),
      setTimeout(
        () => (!1 === this._visible(e) || e.parentElement.removeChild(e), t()),
        410
      ),
      !0
    );
  },
  _visible: function (e) {
    return (
      null != (e = e || document.querySelector(".basicLightbox")) &&
      !0 === e.ownerDocument.body.contains(e)
    );
  },
  create: function (e, t) {
    (e = this._validateContent(e)), (t = this._validateOptions(t));
    const n = this._render(e, t),
      i = (e, i) =>
        !1 !== t.onShow(s) &&
        this._show(n, () => {
          if (
            ("string" == typeof i &&
              n.querySelectorAll(i) &&
              n.querySelectorAll(i)[0].focus(),
            "function" == typeof e)
          )
            return e(s);
        }),
      o = (e) =>
        !1 !== t.onClose(s) &&
        this._close(n, () => {
          if ("function" == typeof e) return e(s);
        });
    !0 === t.closable &&
      (n.addEventListener("click", (e) => {
        e.target === n && o();
      }),
      window.addEventListener("keydown", (e) => {
        27 == e.keyCode && o();
      }),
      n.querySelector(".basicLightboxClose") &&
        (n
          .querySelector(".basicLightboxClose")
          .addEventListener("click", (e) => {
            e.preventDefault(), o();
          }),
        n
          .querySelector(".basicLightboxClose")
          .addEventListener("keydown", (e) => {
            13 == e.keyCode && o();
          }))),
      t.trigger &&
        (t.trigger.addEventListener("click", (e) => {
          e.preventDefault(), i(null, t.focus);
        }),
        t.trigger.addEventListener("keydown", (e) => {
          13 == e.keyCode && i(null, t.focus);
        }));
    const s = {
      element: () => n,
      visible: () => this._visible(n),
      show: i,
      close: o,
    };
    return s;
  },
};
!(function () {
  "use strict";
  function o() {
    var o = window,
      t = document;
    if (
      !("scrollBehavior" in t.documentElement.style) ||
      !0 === o.__forceSmoothScrollPolyfill__
    ) {
      var l,
        e = o.HTMLElement || o.Element,
        r = 468,
        i = {
          scroll: o.scroll || o.scrollTo,
          scrollBy: o.scrollBy,
          elementScroll: e.prototype.scroll || n,
          scrollIntoView: e.prototype.scrollIntoView,
        },
        s =
          o.performance && o.performance.now
            ? o.performance.now.bind(o.performance)
            : Date.now,
        c =
          ((l = o.navigator.userAgent),
          new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(l) ? 1 : 0);
      (o.scroll = o.scrollTo =
        function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? h.call(
                  o,
                  t.body,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : o.scrollY || o.pageYOffset
                )
              : i.scroll.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : o.scrollY || o.pageYOffset
                ));
        }),
        (o.scrollBy = function () {
          void 0 !== arguments[0] &&
            (f(arguments[0])
              ? i.scrollBy.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : 0,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : 0
                )
              : h.call(
                  o,
                  t.body,
                  ~~arguments[0].left + (o.scrollX || o.pageXOffset),
                  ~~arguments[0].top + (o.scrollY || o.pageYOffset)
                ));
        }),
        (e.prototype.scroll = e.prototype.scrollTo =
          function () {
            if (void 0 !== arguments[0])
              if (!0 !== f(arguments[0])) {
                var o = arguments[0].left,
                  t = arguments[0].top;
                h.call(
                  this,
                  this,
                  void 0 === o ? this.scrollLeft : ~~o,
                  void 0 === t ? this.scrollTop : ~~t
                );
              } else {
                if ("number" == typeof arguments[0] && void 0 === arguments[1])
                  throw new SyntaxError("Value could not be converted");
                i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : "object" != typeof arguments[0]
                    ? ~~arguments[0]
                    : this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : void 0 !== arguments[1]
                    ? ~~arguments[1]
                    : this.scrollTop
                );
              }
          }),
        (e.prototype.scrollBy = function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? this.scroll({
                  left: ~~arguments[0].left + this.scrollLeft,
                  top: ~~arguments[0].top + this.scrollTop,
                  behavior: arguments[0].behavior,
                })
              : i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left + this.scrollLeft
                    : ~~arguments[0] + this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top + this.scrollTop
                    : ~~arguments[1] + this.scrollTop
                ));
        }),
        (e.prototype.scrollIntoView = function () {
          if (!0 !== f(arguments[0])) {
            var l = (function (o) {
                for (
                  ;
                  o !== t.body &&
                  !1 ===
                    ((e = p((l = o), "Y") && a(l, "Y")),
                    (r = p(l, "X") && a(l, "X")),
                    e || r);

                )
                  o = o.parentNode || o.host;
                var l, e, r;
                return o;
              })(this),
              e = l.getBoundingClientRect(),
              r = this.getBoundingClientRect();
            l !== t.body
              ? (h.call(
                  this,
                  l,
                  l.scrollLeft + r.left - e.left,
                  l.scrollTop + r.top - e.top
                ),
                "fixed" !== o.getComputedStyle(l).position &&
                  o.scrollBy({ left: e.left, top: e.top, behavior: "smooth" }))
              : o.scrollBy({ left: r.left, top: r.top, behavior: "smooth" });
          } else
            i.scrollIntoView.call(
              this,
              void 0 === arguments[0] || arguments[0]
            );
        });
    }
    function n(o, t) {
      (this.scrollLeft = o), (this.scrollTop = t);
    }
    function f(o) {
      if (
        null === o ||
        "object" != typeof o ||
        void 0 === o.behavior ||
        "auto" === o.behavior ||
        "instant" === o.behavior
      )
        return !0;
      if ("object" == typeof o && "smooth" === o.behavior) return !1;
      throw new TypeError(
        "behavior member of ScrollOptions " +
          o.behavior +
          " is not a valid value for enumeration ScrollBehavior."
      );
    }
    function p(o, t) {
      return "Y" === t
        ? o.clientHeight + c < o.scrollHeight
        : "X" === t
        ? o.clientWidth + c < o.scrollWidth
        : void 0;
    }
    function a(t, l) {
      var e = o.getComputedStyle(t, null)["overflow" + l];
      return "auto" === e || "scroll" === e;
    }
    function d(t) {
      var l,
        e,
        i,
        c,
        n = (s() - t.startTime) / r;
      (c = n = n > 1 ? 1 : n),
        (l = 0.5 * (1 - Math.cos(Math.PI * c))),
        (e = t.startX + (t.x - t.startX) * l),
        (i = t.startY + (t.y - t.startY) * l),
        t.method.call(t.scrollable, e, i),
        (e === t.x && i === t.y) || o.requestAnimationFrame(d.bind(o, t));
    }
    function h(l, e, r) {
      var c,
        f,
        p,
        a,
        h = s();
      l === t.body
        ? ((c = o),
          (f = o.scrollX || o.pageXOffset),
          (p = o.scrollY || o.pageYOffset),
          (a = i.scroll))
        : ((c = l), (f = l.scrollLeft), (p = l.scrollTop), (a = n)),
        d({
          scrollable: c,
          method: a,
          startTime: h,
          startX: f,
          startY: p,
          x: e,
          y: r,
        });
    }
  }
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = { polyfill: o })
    : o();
})();
class AnnouncementBar extends HTMLElement {
  constructor() {
    super(),
      document.querySelector(".announcement__exit") &&
        document
          .querySelector(".announcement__exit")
          .addEventListener("click", () => {
            document.body.classList.add("no-transition"),
              setTimeout(() => {
                document.body.classList.remove("show-announcement-bar"),
                  localStorage.setItem("announcement-dismissed", "true"),
                  setTimeout(() => {
                    document.body.classList.remove("no-transitions");
                  }, 100);
              }, 10);
          });
  }
}
customElements.define("announcement-bar", AnnouncementBar);
const toggleAnnouncement = (e) => {
  e.target.classList.contains("mount-announcement") &&
    (document.querySelector(".announcement")
      ? document.body.classList.add("show-announcement-bar")
      : document.body.classList.remove("show-announcement-bar"));
};
document.addEventListener("shopify:section:load", toggleAnnouncement),
  document.addEventListener("shopify:section:select", toggleAnnouncement);
class CartForm extends HTMLElement {
  constructor() {
    super(), this.ajaxifyCartItems();
  }
  ajaxifyCartItems() {
    (this.form = this.querySelector("form")),
      this.querySelectorAll(".cart-item").forEach((t) => {
        const e = t.querySelector(".remove");
        e &&
          ((e.dataset.href = e.getAttribute("href")),
          e.setAttribute("href", ""),
          e.addEventListener("click", (e) => {
            e.preventDefault(), this.updateCartQty(t, 0);
          }));
        const r = t.querySelector(".qty");
        r &&
          (r.addEventListener(
            "input",
            debounce((e) => {
              e.preventDefault(),
                e.target.blur(),
                this.updateCartQty(t, parseInt(r.value));
            }, 300)
          ),
          r.addEventListener("click", (t) => {
            t.target.select();
          }));
      });
  }
  updateCartQty(t, e) {
    this.form.classList.add("processing"),
      this.querySelector(".alert") && this.querySelector(".alert").remove();
    const r = JSON.stringify({ id: t.dataset.id, quantity: e });
    fetch(KROWN.settings.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
      },
      body: r,
    })
      .then((t) => {
        if (t.ok) return fetch("?section_id=cart-helper");
        throw new Error("Something went wrong");
      })
      .then((t) => t.text())
      .then((r) => {
        const a = new DOMParser().parseFromString(r, "text/html"),
          n = a.getElementById("AjaxCartForm").innerHTML,
          s = a.getElementById("AjaxCartSubtotal").innerHTML,
          o = document.getElementById("AjaxCartForm");
        if (
          ((o.innerHTML = n),
          o.ajaxifyCartItems(),
          (document.querySelector("[data-header-cart-count]").textContent =
            o.querySelector("[data-cart-count]").textContent),
          0 != e &&
            e >
              parseInt(
                o.querySelector(`.cart-item[data-id="${t.dataset.id}"]`).dataset
                  .qty
              ))
        ) {
          let e = document.createElement("span");
          e.classList.add("alert", "alert--error"),
            (e.textContent = KROWN.settings.locales.cart_add_error.replace(
              "{{ title }}",
              t.dataset.title
            )),
            this.form.prepend(e);
        }
        (document.getElementById("AjaxCartSubtotal").innerHTML = s),
          window.preloadImages(o);
      })
      .catch((t) => {
        console.log(t);
        let e = document.createElement("span");
        e.classList.add("alert", "alert--error"),
          (e.textContent = KROWN.settings.locales.cart_general_error),
          this.form.prepend(e);
      })
      .finally(() => {
        this.form.classList.remove("processing");
      });
  }
}
customElements.define("cart-form", CartForm);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.filterData = []),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500)),
      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      ),
      this.classList.contains("don-t-duplicate") ||
        ((document.getElementById("FacetFiltersFormMobile").innerHTML =
          document.getElementById("FacetFiltersForm").innerHTML),
        document
          .getElementById("FacetFiltersFormMobile")
          .addEventListener("input", this.debouncedOnSubmit.bind(this)),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelectorAll(".facets__item")
          .forEach((e) => {
            const t = e.querySelector("input").id;
            e.querySelector("label").setAttribute("for", "mobile-" + t),
              (e.querySelector("input").id = "mobile-" + t);
          }),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.remove("active-facets-desktop"),
        document
          .getElementById("FacetFiltersFormMobile")
          .querySelector(".active-facets")
          .classList.add("active-facets-mobile"));
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const i = FacetFiltersForm.getSections();
    document
      .getElementById("main-collection-product-grid")
      .classList.add("loading"),
      i.forEach((r) => {
        const i = `${window.location.pathname}?section_id=${r.section}&${e}`,
          c = (e) => e.url === i;
        FacetFiltersForm.filterData.some(c)
          ? FacetFiltersForm.renderSectionFromCache(c, t)
          : FacetFiltersForm.renderSectionFromFetch(i, t);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        const i = r;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: i, url: e },
        ]),
          FacetFiltersForm.renderFilters(i, t),
          FacetFiltersForm.renderProductGrid(i),
          FacetFiltersForm.renderProductCount(i);
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderProductGrid(r),
      FacetFiltersForm.renderProductCount(r);
  }
  static renderProductGrid(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductGrid").innerHTML;
    (document.getElementById("CollectionProductGrid").innerHTML = t),
      window.preloadImages(document.getElementById("CollectionProductGrid"));
  }
  static renderProductCount(e) {
    const t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductCount");
    t &&
      (document.getElementById("CollectionProductCount").innerHTML =
        t.innerHTML);
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, "text/html"),
      i = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
      ),
      c = (e) => {
        if (t && t.target.closest(".js-filter"))
          return (
            e.dataset.index === t.target.closest(".js-filter").dataset.index
          );
      },
      a = Array.from(i).filter((e) => !c(e)),
      s = Array.from(i).find(c);
    a.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(r),
      s && FacetFiltersForm.renderCounts(s, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const r = e.querySelector(".active-facets");
      r &&
        document.querySelector(t) &&
        (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderCounts(e, t) {
    [".facets__selected"].forEach((r) => {
      const i = t.querySelector(r);
      e.querySelector(r) &&
        i &&
        (t.querySelector(r).outerHTML = e.querySelector(r).outerHTML);
    });
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [
      {
        id: "main-collection-product-grid",
        section: document.getElementById("main-collection-product-grid").dataset
          .id,
      },
    ];
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const t = new FormData(e.target.closest("form")),
      r = new URLSearchParams(t).toString();
    FacetFiltersForm.renderPage(r, e);
  }
  onActiveFilterClick(e) {
    e.preventDefault(),
      FacetFiltersForm.toggleActiveFacets(),
      FacetFiltersForm.renderPage(
        new URL(e.currentTarget.href).searchParams.toString()
      );
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();
        (
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form")
        ).onActiveFilterClick(e);
      });
  }
}
customElements.define("facet-remove", FacetRemove);
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll("input"),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute("max", r.value),
      t.value && r.setAttribute("min", t.value),
      "" === t.value && r.setAttribute("min", 0),
      "" === r.value && t.setAttribute("max", r.getAttribute("max"));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute("min")),
      i = Number(e.getAttribute("max"));
    t < r && (e.value = r), t > i && (e.value = i);
  }
}
customElements.define("price-range", PriceRange);
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.selector = this.querySelector(".regular-select-cover")),
      (this.content = this.querySelector(".regular-select-content")),
      this.selector.addEventListener("click", (e) => {
        e.stopPropagation(),
          e.preventDefault(),
          document
            .querySelectorAll(".regular-select-cover.content-opened")
            .forEach((t) => {
              t != e.currentTarget &&
                (t.classList.remove("content-opened"),
                (t.parentNode.style.zIndex = 9));
            }),
          this.content.classList.contains("content-opened")
            ? (e.currentTarget.setAttribute("aria-expanded", "false"),
              (this.content.parentNode.style.zIndex = 9),
              this.content.classList.remove("content-opened", "invert"),
              window.removeEventListener("click", this.onClickHandler))
            : (this.content.classList.add("content-opened"),
              e.currentTarget.setAttribute("aria-expanded", "true"),
              (this.content.parentNode.style.zIndex = 1e3),
              this.content.classList.contains("invert-with-fixed") &&
                this.content.getBoundingClientRect().y +
                  this.content.offsetHeight +
                  55 >
                  window.innerHeight &&
                this.content.classList.add("invert"),
              (this.onClickHandler = (() => {
                this.content.classList.contains("content-opened") &&
                  (this.content.classList.remove("content-opened", "invert"),
                  (this.content.parentNode.style.zIndex = 9));
              }).bind(this)),
              window.addEventListener("click", this.onClickHandler));
      }),
      this.querySelector(".regular-select-cover").addEventListener(
        "keydown",
        function (e) {
          e.keyCode == window.KEYCODES.RETURN &&
            (this.content.classList.contains("opened-with-tab") ||
              (this.content.classList.add("opened-with-tab"),
              this.content
                .querySelectorAll(".regular-select-item")
                .forEach((e) => {
                  e.setAttribute("tabindex", "0");
                })));
        }
      );
  }
}
customElements.define("localization-form", LocalizationForm);
class ModalBox extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.o = {
        show: 10,
        frequency: "day",
        enabled: !0,
        ...JSON.parse(this.dataset.options),
      }),
      (this._modalKey = `modal-${document.location.hostname}-${this.id}`),
      (this._modalStorage = localStorage.getItem(this._modalKey)
        ? JSON.parse(localStorage.getItem(this._modalKey))
        : "empty"),
      (this._modalText = this.extractText(
        this.querySelector("[data-content]")
      )),
      this.o.enabled)
    ) {
      const e = new Date().getTime(),
        t = Math.round((e - this._modalStorage.shown) / 1e3);
      let o = !1;
      ("empty" == this._modalStorage ||
        ("day" == this.o.frequency && t > 86400) ||
        ("week" == this.o.frequency && t > 604800) ||
        ("month" == this.o.frequency && t > 2419200) ||
        this._modalStorage.content != this._modalText) &&
        (o = !0),
        o &&
          (setTimeout(() => {
            this.show();
          }, parseInt(1e3 * this.o.show)),
          setTimeout(() => {
            this.querySelectorAll("[data-close]").forEach((e) =>
              e.addEventListener("click", () => {
                this.hide(!0);
              })
            );
          }, 100));
    }
    this.setAttribute("style", "");
  }
  show() {
    window.preloadImages(this), this.classList.add("active");
  }
  hide(e = !1) {
    this.classList.remove("active"),
      e &&
        !Shopify.designMode &&
        localStorage.setItem(
          this._modalKey,
          JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText,
          })
        );
  }
  extractText(e) {
    let t = document.createElement("span");
    t.innerHTML = e.innerHTML;
    const o = t.textContent || t.innerText;
    return t.remove(), [o].toString().replace(/ +/g, "");
  }
}
customElements.define("modal-box", ModalBox),
  document.addEventListener("shopify:section:select", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").show();
  }),
  document.addEventListener("shopify:section:deselect", (e) => {
    e.target.classList.contains("mount-popup") &&
      e.target.querySelector("modal-box").hide();
  });
class ProductVariants extends HTMLElement {
  constructor() {
    super(),
      (this.price = document.querySelector(
        "#product-price-" + this.dataset.id
      )),
      this.price &&
        ((this.priceOriginal = this.price.querySelector(
          ".product__price--original"
        )),
        (this.priceCompare = this.price.querySelector(
          ".product__price--compare"
        )),
        (this.priceUnit = this.price.querySelector(".product__price--unit"))),
      (this.productForm = document.querySelector(
        "#product-form-" + this.dataset.id
      )),
      this.productForm &&
        ((this.productQty =
          this.productForm.querySelector(".product__quantity")),
        (this.addToCart = this.productForm.querySelector(
          ".product__add-to-cart"
        )),
        (this.addToCartText =
          this.productForm.querySelector(".add-to-cart__text"))),
      (this.productSKU = document.querySelector(
        `#product-${this.dataset.id} .product__sku`
      )),
      (this.productBARCODE = document.querySelector(
        `#product-${this.dataset.id} .product__barcode`
      )),
      this.addEventListener("change", this.onVariantChange),
      this.updateOptions(),
      this.updateMasterId(),
      this.updateUnavailableVariants(),
      (this.productStock = this.querySelector(".variant-quantity")),
      this.productStock &&
        this.querySelector(".variant-quantity-data") &&
        (this.productStockData = JSON.parse(
          this.querySelector(".variant-quantity-data").dataset.inventory
        )),
      this.updateStock(),
      (this._event = new Event("VARIANT_CHANGE"));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.updateVariantInput(),
      this.price && this.updatePrice(),
      this.updateStock(),
      this.updateUnavailableVariants(),
      this.updatePickupAvailability(),
      this.hasAttribute("data-no-history") || this.updateURL(),
      this.updateDetails(),
      this.productForm &&
        (this.currentVariant && this.currentVariant.available
          ? (this.productQty && (this.productQty.style.display = ""),
            this.addToCart.classList.remove("disabled"),
            this.productForm.classList.remove("disabled-cart"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_add_to_cart_button))
          : (this.productQty && (this.productQty.style.display = "none"),
            this.addToCart.classList.add("disabled"),
            this.productForm.classList.add("disabled-cart"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_sold_out_variant)),
        this.currentVariant
          ? this.productForm.classList.remove("unavailable-variant")
          : (this.productForm.classList.add("unavailable-variant"),
            (this.addToCartText.textContent =
              KROWN.settings.locales.products_unavailable_variant))),
      this.dispatchEvent(this._event);
  }
  updateOptions() {
    "select" == this.dataset.type
      ? (this.options = Array.from(
          this.querySelectorAll(".product-variant-container"),
          (t) => t.value
        ))
      : "radio" == this.dataset.type &&
        ((this.options = []),
        this.querySelectorAll(".product-variant__input").forEach((t) => {
          t.checked && this.options.push(t.value);
        }));
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
    );
  }
  updatePrice() {
    this.currentVariant
      ? ((this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(
          this.currentVariant.price,
          KROWN.settings.shop_money_format
        )),
        this.currentVariant.compare_at_price > this.currentVariant.price
          ? ((this.priceCompare.innerHTML = KROWN.helpers.formatMoney(
              this.currentVariant.compare_at_price,
              KROWN.settings.shop_money_format
            )),
            (this.priceCompare.style.display = ""))
          : (this.priceCompare.style.display = "none"),
        this.currentVariant.unit_price_measurement
          ? (this.priceUnit.innerHTML = `\n\t\t\t\t\t${KROWN.helpers.formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} / \n\t\t\t\t\t${
              1 != this.currentVariant.unit_price_measurement.reference_value
                ? this.currentVariant.unit_price_measurement.reference_value +
                  " "
                : ""
            }\n\t\t\t\t\t${
              this.currentVariant.unit_price_measurement.reference_unit
            }\n\t\t\t\t`)
          : (this.priceUnit.innerHTML = ""))
      : ((this.priceOriginal.innerHTML = ""),
        (this.priceCompare.style.display = "none"),
        (this.priceUnit.innerHTML = ""));
  }
  updateStock() {
    if (this.currentVariant) {
      if (this.productStock && this.productStockData) {
        let t = !1;
        for (const e of this.productStockData)
          if (e.id == this.currentVariant.id) {
            t = e;
            break;
          }
        (this.productStock.innerHTML = ""),
          t &&
            (t.quantity <= 0
              ? "continue" == t.inventory
                ? (this.productStock.innerHTML =
                    KROWN.settings.locales.products_preorder)
                : "deny" == t.inventory &&
                  (this.productStock.innerHTML =
                    KROWN.settings.locales.products_no_products)
              : "1" == t.quantity
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_one_product)
              : t.quantity <= 5
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    t.quantity
                  ))
              : t.unavailable
              ? (this.productStock.innerHTML =
                  KROWN.settings.locales.products_no_products)
              : t.quantity > 5 &&
                "always" == this.productStock.dataset.type &&
                (this.productStock.innerHTML =
                  KROWN.settings.locales.products_few_products.replace(
                    "{{ count }}",
                    t.quantity
                  )));
      }
    } else this.productStock && (this.productStock.innerHTML = "");
  }
  updateDetails() {
    this.productSKU &&
      (this.currentVariant.sku
        ? (this.productSKU.textContent =
            KROWN.settings.locales.product_sku + this.currentVariant.sku)
        : (this.productSKU.textContent = "")),
      this.productBARCODE &&
        (this.currentVariant.barcode
          ? (this.productBARCODE.textContent =
              KROWN.settings.locales.product_barcode +
              this.currentVariant.barcode)
          : (this.productBARCODE.textContent = ""));
  }
  updatePickupAvailability() {
    const t = document.querySelector("pickup-availability");
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute("available"), (t.innerHTML = "")));
  }
  updateUnavailableVariants() {
    if ("true" == this.dataset.hideVariants) {
      let t = {},
        e = {},
        i = {},
        r = null,
        a = null;
      this.dataset.variants > 1 &&
        ((r = this._getSelectedOption(0)), this._resetDisabledOption(1)),
        this.dataset.variants > 2 &&
          ((a = this._getSelectedOption(1)), this._resetDisabledOption(2)),
        this.getVariantData().forEach((s) => {
          this.dataset.variants > 0 &&
            (t[s.option1] || (t[s.option1] = []),
            t[s.option1].push(String(s.available))),
            this.dataset.variants > 1 &&
              (e[s.option2] || (e[s.option2] = []),
              e[s.option2].push(String(s.available))),
            2 == this.dataset.variants &&
              (s.option1 != r ||
                s.available ||
                this._setDisabledOption(1, s.option2)),
            this.dataset.variants > 2 &&
              (i[s.option3] || (i[s.option3] = []),
              i[s.option3].push(String(s.available)),
              s.option2 != a ||
                s.option1 != r ||
                s.available ||
                this._setDisabledOption(2, s.option3));
        }),
        this.dataset.variants > 0 &&
          Object.keys(t).forEach((e) => {
            t[e].includes("true") ||
              this.querySelectorAll(".product-variant")[0]
                .querySelector(`.product-variant-value[value="${e}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 1 &&
          Object.keys(e).forEach((t) => {
            e[t].includes("true") ||
              this.querySelectorAll(".product-variant")[1]
                .querySelector(`.product-variant-value[value="${t}"]`)
                .setAttribute("disabled", "disabled");
          }),
        this.dataset.variants > 2 &&
          (Object.keys(i).forEach((t) => {
            i[t].includes("true") ||
              this.querySelectorAll(".product-variant")[2]
                .querySelector(`.product-variant-value[value="${t}"]`)
                .setAttribute("disabled", "disabled");
          }),
          Object.keys(e).forEach((t) => {
            e[t].includes("true") ||
              (a == t &&
                this.querySelectorAll(".product-variant")[2]
                  .querySelector(".product-variant-value")
                  .setAttribute("disabled", "disabled"));
          }));
    }
  }
  _getSelectedOption(t) {
    if ("select" == this.dataset.type)
      return this.querySelectorAll(".product-variant")[t].querySelector(
        ".product-variant-container"
      ).value;
    if ("radio" == this.dataset.type) {
      let e = null;
      return (
        this.querySelectorAll(".product-variant")
          [t].querySelectorAll(".product-variant__input")
          .forEach((t) => {
            t.checked && (e = t.value);
          }),
        e
      );
    }
  }
  _resetDisabledOption(t) {
    this.querySelectorAll(".product-variant")
      [t].querySelectorAll(".product-variant-value")
      .forEach((t) => {
        t.removeAttribute("disabled");
      });
  }
  _setDisabledOption(t, e) {
    this.querySelectorAll(".product-variant")
      [t].querySelector(`.product-variant-value[value="${e}"]`)
      .setAttribute("disabled", "disabled");
  }
  updateURL() {
    this.currentVariant &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    if (!this.currentVariant) return;
    document
      .querySelectorAll(
        `#product-form-${this.dataset.id}, #product-form-installment`
      )
      .forEach((t) => {
        const e = t.querySelector('input[name="id"]');
        (e.value = this.currentVariant.id),
          e.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("product-variants", ProductVariants);
class ProductForm extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.hasAttribute("data-ajax-cart") &&
      !document.body.classList.contains("template-cart") &&
      ((this.form = this.querySelector("form")),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      (this.ADD_TO_CART = new Event("add-to-cart")));
  }
  onSubmitHandler(t) {
    t.preventDefault();
    const e = this.querySelector('[type="submit"]');
    e.classList.add("working");
    const i = serializeForm(this.form);
    let r = "";
    fetch(KROWN.settings.routes.cart_add_url + ".js", {
      body: i,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "POST",
    })
      .then((t) => t.json())
      .then((t) =>
        422 == t.status
          ? ((r = document.createElement("span")),
            (r.className = "alert body-text-sm alert--error"),
            (r.innerHTML = t.description),
            fetch("?section_id=cart-helper"))
          : fetch("?section_id=cart-helper")
      )
      .then((t) => t.text())
      .then((t) => {
        const e = new DOMParser().parseFromString(t, "text/html"),
          i = e.getElementById("AjaxCartForm").innerHTML,
          a = e.getElementById("AjaxCartSubtotal").innerHTML,
          s = document.getElementById("AjaxCartForm");
        (s.innerHTML = i),
          s.ajaxifyCartItems(),
          "" != r &&
            document
              .getElementById("AjaxCartForm")
              .querySelector("form")
              .prepend(r),
          (document.getElementById("AjaxCartSubtotal").innerHTML = a),
          window.preloadImages(s),
          (document.querySelector("[data-header-cart-count]").textContent =
            document.querySelector(
              "#AjaxCartForm [data-cart-count]"
            ).textContent),
          this.dispatchEvent(this.ADD_TO_CART);
      })
      .catch((t) => {
        console.log(t);
      })
      .finally(() => {
        e.classList.remove("working");
      });
  }
}
customElements.define("product-form", ProductForm);
class PickupAvailability extends HTMLElement {
  constructor() {
    super(),
      (this.errorHtml = this.querySelector(
        "template"
      ).content.firstElementChild.cloneNode(!0)),
      (this.onClickRefreshList = this.onClickRefreshList.bind(this)),
      this.hasAttribute("available") &&
        this.fetchAvailability(this.dataset.variantId);
  }
  fetchAvailability(t) {
    const e = `${this.dataset.baseUrl}variants/${t}/?section_id=pickup-availability`;
    fetch(e)
      .then((t) => t.text())
      .then((t) => {
        const e = new DOMParser()
          .parseFromString(t, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(e);
      })
      .catch((t) => {
        console.log(t),
          this.querySelector("button") &&
            this.querySelector("button").removeEventListener(
              "click",
              this.onClickRefreshList
            ),
          this.renderError();
      });
  }
  onClickRefreshList() {
    this.fetchAvailability(this.dataset.variantId);
  }
  renderError() {
    (this.innerHTML = ""),
      this.appendChild(this.errorHtml),
      this.querySelector("button").addEventListener(
        "click",
        this.onClickRefreshList
      );
  }
  renderPreview(t) {
    const e = document.getElementById("PickupAvailabilityDrawer");
    if ((e && e.remove(), !t.querySelector("pickup-availability-preview")))
      return (this.innerHTML = ""), void this.removeAttribute("available");

    (this.innerHTML = t.querySelector("pickup-availability-preview").outerHTML),
      this.setAttribute("available", ""),
      document.body.appendChild(t.querySelector("#PickupAvailabilityDrawer")),
      this.querySelector("button").addEventListener("click", (t) => {
        document.getElementById("PickupAvailabilityDrawer").show(t.target);
      }),
      this.querySelector("button").addEventListener("keyup", (t) => {
        t.keyCode == window.KEYCODES.RETURN &&
          document
            .getElementById("PickupAvailabilityDrawer")
            .querySelector("[data-close]")
            .focus();
      });
  }
}
customElements.define("pickup-availability", PickupAvailability);
class ProductImageZoom extends HTMLElement {
  constructor() {
    super(),
      document.getElementById("zoom")
        ? (this.zoom = document.getElementById("zoom"))
        : ((this.zoom = document.createElement("div")),
          (this.zoom.id = "zoom"),
          (this.zoom.innerHTML = `\n\t\t\t\t<img />\n\t\t\t\t<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>\n\t\t\t\t<div class="zoom__overlay"></div>\n\t\t\t`),
          document.body.append(this.zoom),
          this.zoom
            .querySelector(".zoom__exit")
            .addEventListener("click", this._productZoomUnmount.bind(this))),
      (this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this)),
      (this.onResizeHandlerBinded = this.onResizeHandler.bind(this)),
      this.addEventListener("click", (t) => {
        this.zoom.classList.add("opened"),
          (this.image = this.zoom.querySelector("img")),
          (this.image.src = this.getAttribute("data-image")),
          this.image.naturalWidth > 0
            ? this._productZoomMount()
            : this.image.addEventListener(
                "load",
                this._productZoomMount.bind(this)
              );
      });
  }
  onMouseMoveHandler(t) {
    (window.clientX = t.clientX), (window.clientY = t.clientY);
    const e =
        (t.clientX * (window.innerWidth - this.image.offsetWidth)) /
        window.innerWidth,
      i =
        (t.clientY * (window.innerHeight - this.image.offsetHeight)) /
        window.innerHeight;
    (this.image.style.left = e + "px"), (this.image.style.top = i + "px");
  }
  onResizeHandler() {
    const t = window.innerWidth > 768 ? 1 : 2;
    this.image.classList.contains("portrait")
      ? ((this.image.style.width = window.innerWidth * t + "px"),
        (this.image.style.height =
          (window.innerWidth * t) / this.image.dataset.ratio + "px"))
      : ((this.image.style.height = window.innerHeight * t + "px"),
        (this.image.style.width =
          window.innerHeight * t * this.image.dataset.ratio + "px"),
        this.image.offsetWidth < window.innerWidth &&
          ((this.image.style.width = window.innerWidth * t + "px"),
          (this.image.style.height =
            (window.innerWidth * t) / this.image.dataset.ratio + "px")));
    window.clientX,
      window.innerWidth,
      this.image.offsetWidth,
      window.innerWidth,
      window.clientY,
      window.innerHeight,
      this.image.offsetHeight,
      window.innerHeight;
  }
  _productZoomMount(t) {
    (this.image.style.left = 0),
      (this.image.style.top = 0),
      window.addEventListener("mousemove", this.onMouseMoveHandlerBinded, {
        passive: !0,
      }),
      (this.image.dataset.ratio =
        this.image.naturalWidth / this.image.naturalHeight),
      window.addEventListener("resize", this.onResizeHandlerBinded, {
        passive: !0,
      }),
      this.onResizeHandler(),
      setTimeout(() => {
        (document.body.classList.contains("touch") ||
          document.body.classList.contains("touchevents")) &&
          ((this.zoom.scrollTop =
            (window.innerHeight - this.image.offsetHeight) / -2),
          (this.zoom.scrollLeft =
            (window.innerWidth - this.image.offsetWidth) / -2)),
          this.zoom.classList.add("loaded");
      }, 50);
  }
  _productZoomUnmount() {
    this.zoom.classList.remove("opened"),
      setTimeout(() => {
        window.removeEventListener("resize", this.onResizeHandlerBinded),
          window.removeEventListener(
            "mousemove",
            this.onMouseMoveHandlerBinded
          );
        const t = document.querySelector("#zoom img");
        (t.src = ""),
          (t.className = ""),
          (t.style = ""),
          this.zoom.classList.remove("loaded");
      }, 300);
  }
}
customElements.define("product-image-zoom", ProductImageZoom);
class SearchForm extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.cachedResults = {}),
      (this.input = this.querySelector("[data-search-input]")),
      (this.predictiveSearchResults = this.querySelector(
        "[data-search-results]"
      )),
      (this.results = []),
      (this.preloader = !1),
      "false" != KROWN.settings.predictive_search_enabled)
    ) {
      let e = this.input.value;
      this.input.addEventListener(
        "keyup",
        debounce((t) => {
          this.input.value != e
            ? ((e = this.input.value),
              this.getSearchResults(this.input.value.trim()))
            : "" == this.input.value && this.clearSearchResults();
        }, 150)
      ),
        this.input.addEventListener("keydown", (e) => {
          -1 != this.a11yIndex &&
            ((e.keyCode !== window.KEYCODES.UP &&
              e.keyCode !== window.KEYCODES.DOWN &&
              e.keyCode !== window.KEYCODES.RETURN) ||
              e.preventDefault());
        }),
        this.input.addEventListener("keyup", (e) =>
          e.keyCode === window.KEYCODES.UP
            ? (this.navigateThrough("UP"), !0)
            : e.keyCode === window.KEYCODES.DOWN
            ? (this.navigateThrough("DOWN"), !0)
            : void (
                e.keyCode === window.KEYCODES.RETURN &&
                -1 != this.a11yIndex &&
                (document.location.href =
                  this.results[this.a11yIndex].querySelector("a"))
              )
        );
    }
  }
  getSearchResults(e = "") {
    this.preloadSearchResults();
    const t = e.replace(" ", "-").toLowerCase();
    this.cachedResults[t]
      ? this.renderSearchResults(this.cachedResults[t])
      : ((this.a11yIndex = -1),
        fetch(
          `${
            KROWN.settings.routes.predictive_search_url
          }?q=${encodeURIComponent(e)}&resources[type]=${
            this.dataset.resourceType
          }&resources[limit]=4&section_id=predictive-search`
        )
          .then((e) => {
            if (!e.ok) {
              var t = new Error(e.status);
              throw (this.clearSearchResults(), t);
            }
            return e.text();
          })
          .then((e) => {
            const s = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            (this.cachedResults[t] = s), this.renderSearchResults(s);
          })
          .catch((e) => {
            throw e;
          }));
  }
  clearSearchResults() {
    (this.predictiveSearchResults.innerHTML = ""),
      (this.preloader = !1),
      (this.results = []);
  }
  preloadSearchResults() {
    this.preloader ||
      ((this.preloader = !0),
      (this.predictiveSearchResults.innerHTML =
        KROWN.settings.predictive_search_placeholder));
  }
  renderSearchResults(e) {
    (this.predictiveSearchResults.innerHTML = e),
      (this.preloader = !1),
      (this.results = this.predictiveSearchResults.querySelectorAll(
        ".search-item, .sidebar__search-link"
      )),
      window.preloadImages(this.predictiveSearchResults);
  }
  navigateThrough(e) {
    -1 == this.a11yIndex
      ? (this.a11yIndex = 0)
      : (this.results[this.a11yIndex].classList.remove("active"),
        "UP" == e
          ? this.a11yIndex - 1 >= -1 && this.a11yIndex--
          : "DOWN" == e &&
            this.a11yIndex + 1 < this.results.length &&
            this.a11yIndex++),
      this.a11yIndex >= 0
        ? (this.results[this.a11yIndex].classList.add("active"),
          (document.getElementById("site-search-sidebar").scrollTop =
            this.results[this.a11yIndex].offsetTop - 200))
        : (document.getElementById("site-search-sidebar").scrollTop = 0);
  }
}
customElements.define("search-form", SearchForm);
class CSSSlider extends HTMLElement {
  constructor() {
    super(),
      (this._touchScreen =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch));
    const s = navigator.userAgent.toLowerCase();
    (this._ios15 =
      this._touchScreen &&
      s.includes("applewebkit") &&
      (s.includes("os 15_") || s.includes("version/15"))),
      (this.o = {
        selector: ".css-slide",
        snapping: !0,
        groupCells: !1,
        autoHeight: !1,
        navigation: !0,
        navigationDOM:
          '<span class="css-slider-button css-slider-prev" style="display:none"></span>\n\t\t\t\t\t<span class="css-slider-button css-slider-next" style="display:none"></span>',
        thumbnails: !0,
        thumbnailsDOM:
          '<div class="css-slider-dot-navigation" style="display:none"></div>',
        indexNav: !1,
        indexNavDOM:
          '<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>',
        watchCSS: !1,
        undisplay: !1,
        listenScroll: !1,
        ...JSON.parse(this.dataset.options),
      }),
      this.o.watchCSS
        ? ((this.RESIZE_WATCHER = debounce(() => {
            const s = window.getComputedStyle(this, ":after").content;
            s.includes("css-slide") && !this.sliderEnabled
              ? this.initSlider()
              : !s.includes("css-slide") &&
                this.sliderEnabled &&
                this.destroySlider();
          }, 100)),
          window.addEventListener("resize", this.RESIZE_WATCHER),
          this.RESIZE_WATCHER())
        : this.initSlider();
  }
  destroySlider() {
    (this.innerHTML = "" + this.originalHTML),
      this.classList.remove("enabled"),
      (this.sliderEnabled = !1),
      window.removeEventListener("resize", this.RESIZE_EVENT),
      window.removeEventListener("scroll", this.SCROLL_EVENT),
      window.removeEventListener("scroll", this.SCROLL_EVENT_ANIMATION),
      window.preloadImages(this);
  }
  initSlider() {
    if (
      ((this._readyEvent = new CustomEvent("ready")),
      (this._changeEvent = new CustomEvent("change")),
      (this._scrollEvent = new CustomEvent("scroll")),
      (this._navEvent = new CustomEvent("navigation")),
      (this._pointerDownEvent = new CustomEvent("pointerDown")),
      (this._pointerUpEvent = new CustomEvent("pointerUp")),
      this.classList.add("css-slider"),
      (this.originalHTML = this.innerHTML),
      (this.innerHTML = `<div class="css-slider-viewport">\n      <div class="css-slider-holder">\n        <div class="css-slider-container">\n          ${this.originalHTML}\n        </div>\n      </div>\n    </div>`),
      window.preloadImages(this),
      this.o.undisplay &&
        this.querySelectorAll("" + this.o.selector).forEach((s) => {
          s.style.display = "block";
        }),
      ".css-slide" != this.o.selector &&
        this.querySelectorAll("" + this.o.selector).forEach((s) => {
          s.classList.add("css-slide");
        }),
      (this.element = this.querySelector(".css-slider-holder")),
      this.o.groupCells && (this.element.scrollLeft = 0),
      (this.items = this.querySelectorAll("" + this.o.selector)),
      (this.indexedItems = []),
      (this.index = 0),
      (this.length = this.items.length),
      (this.windowWidth = window.innerWidth),
      (this.viewport = this.querySelector(".css-slider-viewport")),
      this.o.autoHeight && this.viewport.classList.add("auto-height"),
      this.o.navigation || this.o.thumbnails || this.indexNav)
    ) {
      console.log("init slider2s", this.o.navigation);

      let s = document.createElement("div");
      s.classList.add("css-slider-navigation-container"),
        (s.innerHTML = `\n        ${
          this.o.navigation ? this.o.navigationDOM : ""
        }\n        ${this.o.thumbnails ? this.o.thumbnailsDOM : ""}\n        ${
          this.o.indexNav ? this.o.indexNavDOM : ""
        }`),
        this.o.navigation &&
          ((this.prevEl = s.querySelector(".css-slider-prev")),
          this.prevEl.addEventListener("click", (s) => {
            this.changeSlide("prev"), this.dispatchEvent(this._navEvent);
          }),
          (this.nextEl = s.querySelector(".css-slider-next")),
          this.nextEl.addEventListener("click", (s) => {
            this.changeSlide("next"), this.dispatchEvent(this._navEvent);
          })),
        this.o.thumbnails &&
          (this.thumbnailsEl = s.querySelector(".css-slider-dot-navigation")),
        this.o.indexNav &&
          ((this.indexEl = s.querySelector(".css-slider-current")),
          (this.lengthEl = s.querySelector(".css-slider-total"))),
        this.append(s);
    }
    this.length > 1 &&
      ((this.RESIZE_EVENT = debounce(() => {
        this.windowWidth != window.innerWidth &&
          this.o.groupCells &&
          this.resetSlider(),
          this.o.groupCells || this.checkSlide(),
          (this.windowWidth = window.innerWidth);
      }, 100)),
      window.addEventListener("resize", this.RESIZE_EVENT),
      this.resetSlider(!0),
      this.o.listenScroll &&
        ((this.SCROLL_EVENT_ANIMATIONS = () => {
          let s = -this.querySelector(".css-slider-container").offsetWidth;
          this.items.forEach((e) => {
            s += e.offsetWidth;
          }),
            (this.progress = this.element.scrollLeft / s),
            this.dispatchEvent(this._scrollEvent);
        }),
        this.element.addEventListener("scroll", this.SCROLL_EVENT_ANIMATIONS, {
          passive: !0,
        })),
      (this.SCROLL_EVENT = debounce(() => {
        if (!this._sliderBlockScroll) {
          const s = this.indexedItems.entries(),
            e = Array.from(s, (s) =>
              Math.abs(s[1].offsetLeft - this.element.scrollLeft)
            ),
            t = Math.min(...e),
            i = e.indexOf(t);
          i != this.index &&
            ((this.index = i),
            this.checkSlide(),
            this.dispatchEvent(this._changeEvent));
        }
      }, 10)),
      this.element.addEventListener("scroll", this.SCROLL_EVENT, {
        passive: !0,
      }),
      this._touchScreen ||
        this.element.classList.contains("css-slider--singular") ||
        (this.element.addEventListener("mousedown", (s) => {
          this.element.classList.contains("css-slider--disable-dragging") ||
            ((this.mouseX = s.screenX),
            this.element.classList.add("can-drag"),
            this.element.classList.add("mouse-down"));
        }),
        this.element.addEventListener("mouseup", (s) => {
          this.element.classList.remove("mouse-down"),
            this.element.classList.remove("can-drag"),
            this.element.classList.remove("pointer-events-off");
        }),
        this.element.addEventListener("mouseleave", (s) => {
          this.element.classList.remove("mouse-down"),
            this.element.classList.remove("can-drag"),
            this.element.classList.remove("pointer-events-off");
        }),
        this.element.addEventListener("mousemove", (s) => {
          if (this.element.classList.contains("can-drag")) {
            this.element.classList.add("pointer-events-off");
            let e = this.mouseX - s.screenX;
            Math.abs(e) > 1 &&
              (e > 0
                ? (this.changeSlide("next"),
                  this.element.classList.remove("can-drag"))
                : e < 0 &&
                  (this.changeSlide("prev"),
                  this.element.classList.remove("can-drag")));
          }
        })),
      "scrollBehavior" in document.documentElement.style ||
        this._touchScreen ||
        this.element.classList.add("force-disable-snapping")),
      this.classList.add("enabled"),
      (this.sliderEnabled = !0),
      this.dispatchEvent(this._readyEvent);
  }
  changeSlide(s, e = "smooth") {
    "next" == s
      ? this.index + 1 < this.length && this.index++
      : "prev" == s
      ? this.index - 1 >= 0 && this.index--
      : parseInt(s) >= 0 && (this.index = parseInt(s)),
      (this._sliderBlockScroll = !0),
      this._ios15 && this.element.classList.add("force-disable-snapping"),
      setTimeout(() => {
        (this._sliderBlockScroll = !1),
          this._ios15 &&
            this.element.classList.remove("force-disable-snapping");
      }, 500),
      this.checkSlide(),
      this.element.scrollTo({
        top: 0,
        left:
          this.indexedItems[this.index].offsetLeft -
          parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
        behavior: e,
      }),
      console.log("test");
    this.dispatchEvent(this._changeEvent);
  }
  checkSlide() {
    this.o.navigation &&
      (this.prevEl.classList.remove("disabled"),
      this.nextEl.classList.remove("disabled"),
      0 == this.index && this.prevEl.classList.add("disabled"),
      this.index == this.length - 1 && this.nextEl.classList.add("disabled")),
      this.o.thumbnails &&
        this.thumbnails &&
        (this.thumbnails.forEach((s) => {
          s.classList.remove("active");
        }),
        this.thumbnails[this.index].classList.add("active")),
      this.o.indexNav && (this.indexEl.textContent = this.index + 1),
      this.o.autoHeight &&
        (this.viewport.style.height =
          this.indexedItems[this.index].offsetHeight + "px"),
      this.indexedItems.forEach((s, e) => {
        e == this.index
          ? s.classList.add("css-slide-active")
          : s.classList.remove("css-slide-active");
      });
  }
  afterAppend() {
    this.items = this.querySelectorAll("" + this.o.selector);
  }
  resetSlider(s = !1, e = !0) {
    let t = 0,
      i = 0,
      n = 0,
      l = this.querySelector(".css-slider-container").offsetWidth,
      h = !1;
    if (
      ((this.indexedItems = []),
      this.element.classList.add("disable-snapping"),
      this.items.forEach((s, e) => {
        s.classList.remove("css-slide--snap"),
          (t += s.offsetWidth),
          t > l && 0 == i && (i = e);
      }),
      0 == i && ((i = this.items.length), (h = !0)),
      this.items.forEach((s, e) => {
        e % i == 0 &&
          (s.classList.add("css-slide--snap"),
          s.setAttribute("data-index", n++));
      }),
      (this.indexedItems = this.querySelectorAll(".css-slide--snap")),
      e && (this.index = 0),
      (this.length = Math.ceil(this.items.length / i)),
      this.o.thumbnails)
    ) {
      this.thumbnailsEl.innerHTML = "";
      for (let s = 0; s < this.length; s++) {
        let e = document.createElement("span");
        e.classList.add("css-slider-dot"),
          (e.dataset.index = s),
          this.thumbnailsEl.appendChild(e),
          e.addEventListener("click", (s) => {
            this.changeSlide(s.target.dataset.index);
          });
      }
      this.thumbnails = this.thumbnailsEl.querySelectorAll(".css-slider-dot");
    }
    this.o.indexNav &&
      ((this.indexEl.textContent = this.index + 1),
      (this.lengthEl.textContent = this.length)),
      h
        ? (this.element.classList.add("css-slider--no-drag"),
          this.o.navigation &&
            ((this.prevEl.style.display = "none"),
            (this.nextEl.style.display = "none")),
          this.o.thumbnails && (this.thumbnailsEl.style.display = "none"))
        : (this.element.classList.remove("css-slider--no-drag"),
          this.o.navigation &&
            ((this.prevEl.style.display = "block"),
            (this.nextEl.style.display = "block")),
          this.o.thumbnails && (this.thumbnailsEl.style.display = "block")),
      this.checkSlide(),
      s || this.element.scrollTo({ top: 0, left: 0, behavior: "auto" }),
      this.element.classList.remove("disable-snapping");
  }
}
customElements.define("css-slider", CSSSlider),
  document.addEventListener("shopify:section:load", (s) => {
    s.target.classList.contains("mount-css-slider") &&
      s.target.querySelector("css-slider") &&
      s.target.querySelectorAll("css-slider").forEach((s) => {
        s.enabled && s.resetSlider();
      });
  });
class ToggleTab extends HTMLElement {
  constructor() {
    super(),
      (this.titleEl = this.querySelector(".toggle__title")),
      (this.contentEl = this.querySelector(".toggle__content")),
      (this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`),
      this.titleEl.addEventListener("click", this.onClickHandler.bind(this)),
      this.titleEl.addEventListener("keydown", (t) => {
        t.keyCode == window.KEYCODES.RETURN && this.onClickHandler();
      });
  }
  onClickHandler() {
    this.titleEl.classList.contains("opened")
      ? (this.titleEl.classList.remove("opened"),
        this.titleEl.setAttribute("aria-expanded", "false"),
        this.slideUp(this.contentEl, 200))
      : (this.titleEl.classList.add("opened"),
        this.titleEl.setAttribute("aria-expanded", "true"),
        this.slideDown(this.contentEl, 200));
  }
  slideUp(t, e) {
    (t.style.transitionProperty = "height, margin, padding"),
      (t.style.transitionDuration = e + "ms"),
      (t.style.boxSizing = "border-box"),
      (t.style.height = t.offsetHeight + "px"),
      t.offsetHeight,
      (t.style.overflow = "hidden"),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      setTimeout(() => {
        (t.style.display = "none"),
          t.style.removeProperty("height"),
          t.style.removeProperty("padding-top"),
          t.style.removeProperty("padding-bottom"),
          t.style.removeProperty("margin-top"),
          t.style.removeProperty("margin-bottom"),
          t.style.removeProperty("overflow"),
          t.style.removeProperty("transition-duration"),
          t.style.removeProperty("transition-property");
      }, e);
  }
  slideDown(t, e) {
    t.style.removeProperty("display");
    var o = window.getComputedStyle(t).display;
    "none" === o && (o = "block"), (t.style.display = o);
    var i = t.offsetHeight;
    (t.style.overflow = "hidden"),
      (t.style.height = 0),
      (t.style.paddingTop = 0),
      (t.style.paddingBottom = 0),
      (t.style.marginTop = 0),
      (t.style.marginBottom = 0),
      t.offsetHeight,
      (t.style.boxSizing = "border-box"),
      (t.style.transitionProperty = "height, margin, padding"),
      (t.style.transitionDuration = e + "ms"),
      (t.style.height = i + "px"),
      t.style.removeProperty("padding-top"),
      t.style.removeProperty("padding-bottom"),
      t.style.removeProperty("margin-top"),
      t.style.removeProperty("margin-bottom"),
      setTimeout(() => {
        t.style.removeProperty("height"),
          t.style.removeProperty("overflow"),
          t.style.removeProperty("transition-duration"),
          t.style.removeProperty("transition-property");
      }, e);
  }
}
customElements.define("toggle-tab", ToggleTab),
  document.addEventListener("shopify:block:select", (t) => {
    const e = t.target;
    e.classList.contains("toggle") &&
      (e.querySelector(".toggle__title").classList.contains("opened") ||
        e.onClickHandler());
  }),
  document.addEventListener("shopify:block:deselect", (t) => {
    const e = t.target;
    e.classList.contains("toggle") &&
      e.querySelector(".toggle__title").classList.contains("opened") &&
      e.onClickHandler();
  });
const isAutoplaySupported = (A) => {
  if ("function" != typeof A) return !1;
  if (sessionStorage.getItem("autoplaySupported"))
    "true" == sessionStorage.getItem("autoplaySupported") ? A(!0) : A(!1);
  else {
    const e =
      "data:video/mp4;base64,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";
    let t = !1,
      o = document.createElement("video");
    o.setAttribute("playsinline", "playsinline"),
      o.setAttribute("muted", "muted"),
      o.setAttribute("autoplay", "autoplay"),
      o.setAttribute("loop", "loop"),
      o.setAttribute("controls", "controls"),
      o.setAttribute("width", 20),
      o.setAttribute("height", 20),
      (o.onplay = () => {
        t = !0;
      }),
      o.setAttribute("src", e),
      (o.style.position = "fixed"),
      (o.style.top = "-20px"),
      (o.style.left = "0px"),
      (o.style.zIndex = "997"),
      document.querySelector("body").appendChild(o);
    let s = o.play();
    void 0 !== s &&
      s
        .then(() => {
          A(!0),
            sessionStorage.setItem("autoplaySupported", "true"),
            o.remove();
        })
        .catch((e) => {
          t || e.toString().includes("interact with the document")
            ? (A(!0), sessionStorage.setItem("autoplaySupported", "true"))
            : (A(!1), sessionStorage.setItem("autoplaySupported", "false")),
            o.remove();
        });
  }
};
class VideoPopup extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".video-popup__link").addEventListener(
        "click",
        (A) => {
          A.preventDefault();
          const e = document.createElement("div");
          e.classList.add("video-popup__blackout"),
            this.append(e),
            setTimeout(() => {
              e.style.opacity = "1";
            }, 10),
            this.classList.add("video-opened"),
            this.querySelector(".video-popup__close") &&
              this.querySelector(".video-popup__close").addEventListener(
                "click",
                (A) => {
                  this.querySelectorAll("iframe, video").forEach((A) => {
                    A.remove();
                  }),
                    e.remove(),
                    this.classList.remove("video-opened");
                }
              ),
            setTimeout(() => {
              pauseAllMedia(),
                this.querySelector(".video-popup__container").appendChild(
                  this.querySelector(
                    "template"
                  ).content.firstElementChild.cloneNode(!0)
                ),
                setTimeout(() => {
                  playMedia(this.closest("[data-video]"));
                }, 500);
            }, 50);
        }
      );
  }
}
customElements.define("video-popup", VideoPopup);
class VideoBackground extends HTMLElement {
  constructor() {
    super(),
      isAutoplaySupported((A) => {
        if (A) {
          const A = this.querySelector(".video-text__background");
          A &&
            ((A.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${A.dataset.src}"></video>`),
            A.querySelector("video").play(),
            setTimeout(() => {
              A.querySelector("video").style.opacity = "1";
            }, 200));
        } else
          this.querySelector(
            ".video-text__background .video-text__image"
          ).style.display = "block";
      });
  }
}
customElements.define("video-background", VideoBackground);
function debounce(e, t) {
  let o;
  return (...a) => {
    clearTimeout(o), (o = setTimeout(() => e.apply(this, a), t));
  };
}
KROWN.helpers = {
  formatMoney: function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    let o = "";
    const a = /\{\{\s*(\w+)\s*\}\}/,
      n = t || moneyFormat;
    function r(e, t, o, a) {
      if (((o = o || ","), (a = a || "."), isNaN(e) || null === e)) return 0;
      const n = (e = (e / 100).toFixed(t)).split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) +
        (n[1] ? a + n[1] : "")
      );
    }
    switch (n.match(a)[1]) {
      case "amount":
        o = r(e, 2);
        break;
      case "amount_no_decimals":
        o = r(e, 0);
        break;
      case "amount_with_comma_separator":
        o = r(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = r(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = r(e, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        o = r(e, 2, "'");
    }
    return n.replace(a, o);
  },
};
const getPseudoContent = (e) => {
    var t = document.querySelector(e);
    return window.getComputedStyle(t, ":after").getPropertyValue("content");
  },
  pauseAllMedia = () => {
    document.querySelectorAll(".product .js-youtube").forEach((e) => {
      e.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }),
      document.querySelectorAll(".product .js-vimeo").forEach((e) => {
        e.contentWindow.postMessage('{"method":"pause"}', "*");
      }),
      document.querySelectorAll(".product video").forEach((e) => e.pause()),
      document.querySelectorAll(".product product-model").forEach((e) => {
        e.modelViewerUI && e.modelViewerUI.pause();
      });
  },
  playMedia = (e) => {
    switch (e.dataset.productMediaType) {
      case "video":
        e.querySelector("video").play();
        break;
      case "external_video-youtube":
        e.querySelector(".js-youtube").contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
        break;
      case "external_video-vimeo":
        e.querySelector(".js-vimeo").contentWindow.postMessage(
          '{"method":"play"}',
          "*"
        );
    }
  },
  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */ serializeForm = (e) => {
    let t = [];
    return (
      Array.prototype.slice.call(e.elements).forEach(function (e) {
        !e.name ||
          e.disabled ||
          ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
          ("select-multiple" !== e.type
            ? (["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked) ||
              t.push(
                encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)
              )
            : Array.prototype.slice.call(e.options).forEach(function (o) {
                o.selected &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(o.value)
                  );
              }));
      }),
      t.join("&")
    );
  },
  getJSONP = (e, t) => {
    var o = "_" + +new Date(),
      a = document.createElement("script"),
      n = document.getElementsByTagName("head")[0] || document.documentElement;
    (window[o] = function (e) {
      n.removeChild(a), t && t(e);
    }),
      (a.src = e.replace("callback=?", "callback=" + o)),
      n.appendChild(a);
  },
  trueTypeOf = (e) =>
    Object.prototype.toString.call(e).slice(8, -1).toLowerCase(),
  htmlEscape = (e) =>
    e
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;"),
  reframe = (e, t) => {
    let o = "string" == typeof e ? document.querySelectorAll(e) : e;
    const a = t || "js-reframe";
    "length" in o || (o = [o]);
    for (let e = 0; e < o.length; e += 1) {
      const t = o[e];
      if (
        -1 !== t.className.split(" ").indexOf(a) ||
        t.style.width.indexOf("%") > -1
      )
        continue;
      const n =
          ((t.getAttribute("height") || t.offsetHeight) /
            (t.getAttribute("width") || t.offsetWidth)) *
          100,
        r = document.createElement("div");
      r.className = a;
      const c = r.style;
      (c.position = "relative"), (c.width = "100%"), (c.paddingTop = n + "%");
      const l = t.style;
      (l.position = "absolute"),
        (l.width = "100%"),
        (l.height = "100%"),
        (l.left = "0"),
        (l.top = "0"),
        t.parentNode.insertBefore(r, t),
        t.parentNode.removeChild(t),
        r.appendChild(t);
    }
  };
window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13,
};
class MainSidebar extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.SCROLL_EVENT = (e) => {
        this.offsetHeight > window.innerHeight
          ? (this.style.transform =
              "translate3d(0," + -1 * window.scrollY + "px, 0)")
          : (this.style.transform =
              "translate3d(0," +
              -1 * (this.offsetHeight - window.innerHeight) +
              "px, 0)");
      }),
      this.addEventListener("scroll", this.SCROLL_EVENT, { passive: !0 }),
      (this.RESIZE_EVENT = debounce(() => {
        this.offsetHeight > window.innerHeight
          ? this.SCROLL_EVENT()
          : (this.style.transform = "translate3d(0, 0, 0)"),
          this.setSidebarHeight();
      }, 300)),
      this.addEventListener("resize", this.RESIZE_EVENT, { passive: !0 }),
      setTimeout(() => {
        this.RESIZE_EVENT();
      }, 310),
      !document.body.classList.contains("template-cart") &&
        "overlay" == KROWN.settings.cart_action)
    ) {
      const e = document.querySelector(".sidebar__cart");
      document.querySelector(".sidebar__cart-handle") &&
        document
          .querySelector(".sidebar__cart-handle")
          .addEventListener("click", (s) => {
            s.preventDefault(), e.show();
          }),
        document.querySelector(".sidebar__cart-handle") &&
          document
            .querySelector(".sidebar__cart-handle")
            .addEventListener("keyup", (e) => {
              e.keyCode == window.KEYCODES.RETURN &&
                setTimeout(() => {
                  document
                    .querySelector(".sidebar__cart .sidebar__cart-close")
                    .focus();
                }, 100);
            });
    }
    const e = document.querySelector(".sidebar__search");
    if ("false" == KROWN.settings.predictive_search_enabled) {
      console.log("if");
      document.querySelector(".sidebar__search-handle") &&
        document
          .querySelector(".sidebar__search-handle")
          .addEventListener("click", (s) => {
            s.preventDefault(),
              e.classList.contains("opened")
                ? e.classList.remove("opened")
                : (e.classList.add("opened"),
                  document
                    .querySelector('.sidebar__search input[type="search"]')
                    .setAttribute(
                      "placeholder",
                      document.querySelector(
                        '.sidebar__search input[type="search"]'
                      ).dataset.responsivePlaceholder
                    ),
                  setTimeout(() => {
                    document
                      .querySelector('.sidebar__search input[type="search"]')
                      .focus();
                  }, 100));
          });
    } else {
      this.closePredictiveSearch = (() => {
        document.querySelector(".sidebar").classList.remove("no-transforms"),
          e.classList.remove("open-search"),
          e.classList.remove("opened"),
          this.querySelector("[data-search-results]").classList.remove("show"),
          this.querySelector("[data-search-link]").classList.remove("show"),
          document.body.classList.remove("overflow-hidden"),
          document
            .querySelector(".cart-overlay-background")
            .classList.remove("show"),
          document
            .querySelector(".cart-overlay-background")
            .removeEventListener("click", this.closePredictiveSearch);
      }).bind(this);

      const search_desktop = document.querySelector(".header__search-icon");
      if (search_desktop) {
        search_desktop.addEventListener("click", (s) => {
          s.preventDefault(),
            e.classList.contains("opened") ? e.hide() : e.show();
        });
      }

      const search_mobile = document.querySelector(".sidebar__search-handle");
      if (search_mobile) {
        search_mobile.addEventListener("click", (s) => {
          window
            .getComputedStyle(e, ":after")
            .content.includes("predictive-mobile") &&
            (s.preventDefault(),
            e.classList.contains("opened") ? e.hide() : e.show());
        });
      }

      const search_input = this.querySelector('input[type="search"]');
      if (search_input) {
        search_input.addEventListener("click", (s) => {
          e.classList.contains("open-search") ||
            (this.setSidebarHeight(),
            document.querySelector(".sidebar").classList.add("no-transforms"),
            e.classList.add("open-search"),
            e.classList.add("opened"),
            this.querySelector("[data-search-results]").classList.add("show"),
            document.body.classList.add("overflow-hidden"),
            document
              .querySelector(".cart-overlay-background")
              .classList.add("show"),
            document
              .querySelector(".cart-overlay-background")
              .addEventListener("click", this.closePredictiveSearch));
        });
      }

      const search_close = this.querySelector(".sidebar__search-close");
      if (search_close) {
        search_close.addEventListener("click", (s) => {
          window
            .getComputedStyle(e, ":after")
            .content.includes("predictive-mobile") ||
            this.closePredictiveSearch();
        });
      }

      document.addEventListener("keydown", (s) => {
        if (s.keyCode == window.KEYCODES.ESC) {
          const s = window.getComputedStyle(e, ":after").content;
          e.classList.contains("open-search") &&
            !s.includes("predictive-mobile") &&
            this.closePredictiveSearch();
        }
      });
    }

    const s = document.querySelector(".sidebar__menus");
    document.querySelector(".sidebar__menu-handle") &&
      document
        .querySelector(".sidebar__menu-handle")
        .addEventListener("click", (e) => {
          e.preventDefault(),
            s.classList.remove("kill-overflow"),
            s.classList.contains("opened") ? s.hide() : s.show();
        });
    let t = 0;
    document
      .querySelectorAll(".sidebar__menus .sidebar__menu .has-submenu > a")
      .forEach((e) => {
        e.addEventListener("click", (r) => {
          window.innerWidth <= 948 &&
            (r.preventDefault(),
            r.stopPropagation(),
            s.classList.add("kill-overflow"),
            (s.scrollTop = 0),
            (t = e.parentNode.classList.contains("has-second-submenu") ? 2 : 1),
            e.parentNode.classList.add("open-submenu"),
            e.parentNode.parentNode.classList.add("opened-submenu"),
            e.closest(".sidebar__menus").classList.add("opened-submenus"),
            e.parentNode.parentNode.parentNode.classList.contains(
              "primary-menu"
            )
              ? e.parentNode.parentNode.parentNode.nextElementSibling.classList.add(
                  "opened-other-submenu"
                )
              : e.parentNode.parentNode.parentNode.previousElementSibling.classList.add(
                  "opened-other-submenu"
                ));
        });
      }),
      document
        .querySelector(".sidebar__menus-back")
        .addEventListener("click", (e) => {
          1 == t
            ? ((t = 0),
              s.classList.remove("opened-submenus"),
              s
                .querySelector("nav.opened-other-submenu")
                .classList.remove("opened-other-submenu"),
              s
                .querySelector(".opened-submenu")
                .classList.remove("opened-submenu"),
              s.querySelector(".open-submenu").classList.remove("open-submenu"),
              s.classList.remove("kill-overflow"))
            : 2 == t &&
              ((t = 1),
              document
                .querySelector(".has-second-submenu.open-submenu")
                .parentNode.classList.remove("opened-submenu"),
              document
                .querySelector(".has-second-submenu.open-submenu")
                .classList.remove("open-submenu"));
        }),
      (this.sidebarParentFLAG = !1),
      (this.sidebarSeconds = document.querySelector(".sidebar__seconds")),
      (this.sidebarSecondsDOM = document.querySelector(
        ".sidebar__seconds .sidebar__menu"
      )),
      (this.sidebarSecondsFLAG = !1),
      (this.sidebarThirds = document.querySelector(".sidebar__thirds")),
      (this.sidebarThirdsDOM = document.querySelector(
        ".sidebar__thirds .sidebar__menu"
      )),
      (this.sidebarThirdsFLAG = !1),
      document.querySelectorAll(".has-first-submenu > a").forEach((e) => {
        e.addEventListener(
          "touchstart",
          (s) => {
            window.innerWidth > 948 &&
              (s.preventDefault(),
              (e.parentNode.querySelectorAll("a")[0].style.pointerEvents =
                "none"),
              this.onMouseEnterHandlerFirst({
                currentTarget: e.parentNode,
                preventDefault: () => {},
              }));
          },
          { passive: !0 }
        );
      }),
      document.querySelectorAll(".has-first-submenu").forEach((e) => {
        e.addEventListener(
          "mouseenter",
          this.onMouseEnterHandlerFirst.bind(this)
        ),
          e.addEventListener(
            "mouseleave",
            this.onMouseLeaveHandlerFirst.bind(this)
          );
      }),
      this.sidebarSeconds.addEventListener("mouseenter", () => {
        document.body.classList.add("show-overlay"),
          this.sidebarSeconds.classList.add("opened"),
          this.sidebarSeconds.querySelector(".sidebar__submenu--first") &&
            this.sidebarSeconds
              .querySelector(".sidebar__submenu--first")
              .classList.add("submenu-opened");
      }),
      this.sidebarSeconds.addEventListener(
        "mouseleave",
        this.onMouseLeaveHandlerFirst.bind(this)
      ),
      this.sidebarThirds.addEventListener("mouseenter", () => {
        document.body.classList.add("show-overlay"),
          this.sidebarThirds.classList.add("opened"),
          this.sidebarSeconds.classList.add("opened"),
          this.sidebarSeconds
            .querySelector(".sidebar__submenu--first")
            .classList.add("submenu-opened"),
          this.sidebarThirds
            .querySelector(".sidebar__submenu--second")
            .classList.add("submenu-opened");
      }),
      this.sidebarThirds.addEventListener("mouseleave", () => {
        this.onMouseLeaveHandlerFirst(), this.onMouseLeaveHandlerSecond();
      });
    let r = document.activeElement,
      n = null,
      a = null,
      d = !1;
    document.addEventListener("keyup", (e) => {
      e.keyCode == window.KEYCODES.TAB &&
        (document.activeElement.classList.contains("parent-has-submenu")
          ? (document.activeElement.parentNode.classList.contains(
              "has-first-submenu"
            )
              ? this.onMouseEnterHandlerFirst({
                  currentTarget: document.activeElement.parentNode,
                  preventDefault: () => {},
                })
              : document.activeElement.parentNode.classList.contains(
                  "has-second-submenu"
                ) &&
                this.onMouseEnterHandlerSecond({
                  currentTarget: document.activeElement.parentNode,
                  preventDefault: () => {},
                }),
            document.activeElement.classList.contains("sub-menu__link-second")
              ? document.activeElement.classList.contains(
                  "sub-menu__last-second"
                )
                ? ((a = n), (d = !0))
                : (a =
                    document.activeElement.parentNode.nextElementSibling.querySelector(
                      ":scope > a"
                    ))
              : document.activeElement.parentNode.nextElementSibling
              ? (n =
                  document.activeElement.parentNode.nextElementSibling.querySelector(
                    ":scope > a"
                  ))
              : "primary" == document.activeElement.dataset.type
              ? (n = document
                  .querySelector(".secondary-menu")
                  .querySelectorAll("a")[0])
              : "secondary" == document.activeElement.dataset.type &&
                (n = document.querySelector(".accounts-menu")
                  ? document
                      .querySelector(".accounts-menu")
                      .querySelectorAll("a")[0]
                  : document.querySelector(".sidebar .localization-form__item")
                  ? document
                      .querySelectorAll(".sidebar .localization-form__item")[0]
                      .querySelectorAll("button")[0]
                  : document.querySelector(".sidebar .sidebar__search form")))
          : r.classList.contains("sub-menu__last-second")
          ? !r.classList.contains("parent-has-submenu") ||
            r.classList.contains("ran-over")
            ? (n && n.focus(), this.onMouseLeaveHandlerFirst())
            : r.classList.add("ran-over")
          : r.classList.contains("sub-menu__last-third") &&
            (a && a.focus(),
            this.onMouseLeaveHandlerSecond(),
            document.activeElement.classList.contains(
              "sub-menu__last-second"
            ) && document.activeElement.classList.contains("ran-over")
              ? (this.onMouseLeaveHandlerFirst(),
                this.onMouseLeaveHandlerSecond(),
                n && n.focus())
              : document.activeElement.parentNode.classList.contains(
                  "has-second-submenu"
                ) &&
                (this.onMouseEnterHandlerSecond({
                  currentTarget: document.activeElement.parentNode,
                  preventDefault: () => {},
                }),
                document.activeElement.classList.contains(
                  "sub-menu__last-second"
                ) ||
                  (a =
                    document.activeElement.parentNode.nextElementSibling.querySelector(
                      ":scope > a"
                    ))),
            d && ((d = !1), this.onMouseLeaveHandlerFirst())),
        (r = document.activeElement));
    }),
      document.addEventListener("keydown", (e) => {
        e.keyCode == window.KEYCODES.TAB
          ? r.classList.contains("parent-has-submenu") &&
            (e.preventDefault(),
            this.sidebarSeconds.querySelectorAll("a")[0].focus(),
            r.classList.contains("sub-menu__link-second") &&
              this.sidebarThirds.querySelectorAll("a")[0].focus())
          : e.keyCode == window.KEYCODES.ESC &&
            (this.sidebarSecondsFLAG && this.onMouseLeaveHandlerFirst(),
            this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond());
      });
  }
  onMouseEnterHandlerFirst(e) {
    if (window.innerWidth > 948) {
      e.preventDefault(),
        document.body.classList.add("show-overlay"),
        this.sidebarSeconds.classList.add("opened"),
        (this.sidebarSecondsFLAG = !0);
      let s = document.createElement("div");
      s.classList.add("clone"),
        (s.innerHTML = e.currentTarget.querySelector(
          ":scope > .sidebar__submenu"
        ).outerHTML),
        (s = s.querySelector(":scope > div")),
        (this.sidebarSecondsDOM.querySelector(".sidebar__submenu") &&
          this.sidebarSecondsDOM.querySelector(".sidebar__submenu").dataset
            .handle == s.dataset.handle) ||
          (this.sidebarSecondsDOM.innerHTML = s.outerHTML),
        (this.sidebarSecondsDOM.querySelector(
          ":scope > .sidebar__submenu .sub-menu"
        ).style.paddingTop =
          e.currentTarget.getBoundingClientRect().top + "px"),
        setTimeout(() => {
          this.sidebarSecondsDOM
            .querySelector(":scope > .sidebar__submenu")
            .classList.add("submenu-opened");
        }, 10),
        this.sidebarSecondsDOM
          .querySelectorAll(".has-second-submenu")
          .forEach((e) => {
            e.addEventListener(
              "touchstart",
              (s) => {
                s.preventDefault(),
                  (e.parentNode.querySelectorAll("a")[0].style.pointerEvents =
                    "none"),
                  this.onMouseEnterHandlerSecond({
                    currentTarget: e,
                    preventDefault: () => {},
                  }),
                  this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond();
              },
              { passive: !0 }
            ),
              e.addEventListener(
                "mouseenter",
                this.onMouseEnterHandlerSecond.bind(this)
              ),
              e.addEventListener("mouseleave", () => {
                this.sidebarThirdsFLAG && this.onMouseLeaveHandlerSecond();
              });
          }),
        e.currentTarget.addEventListener(
          "mouseleave",
          this.onMouseLeaveHandlerSecond.bind(this)
        );
    }
  }
  onMouseEnterHandlerSecond(e) {
    e.preventDefault(),
      this.sidebarThirds.classList.add("opened"),
      (this.sidebarThirdsFLAG = !0);
    let s = document.createElement("div");
    s.classList.add("clone"),
      (s.innerHTML = e.currentTarget.querySelector(
        ":scope > .sidebar__submenu"
      ).outerHTML),
      (s = s.querySelector(":scope > div")),
      (!this.sidebarThirdsDOM.querySelector(".sidebar__submenu") ||
        (this.sidebarThirdsDOM.querySelector(".sidebar__submenu") &&
          this.sidebarThirdsDOM.querySelector(".sidebar__submenu").dataset
            .handle != s.dataset.handle)) &&
        (this.sidebarThirdsDOM.innerHTML = s.outerHTML),
      (this.sidebarThirdsDOM.querySelector(
        ":scope > .sidebar__submenu .sub-menu"
      ).style.paddingTop = e.currentTarget.getBoundingClientRect().top + "px"),
      setTimeout(() => {
        this.sidebarThirdsDOM
          .querySelector(":scope > .sidebar__submenu")
          .classList.add("submenu-opened");
      }, 10);
  }
  onMouseLeaveHandlerFirst() {
    this.sidebarSeconds.classList.remove("opened"),
      this.sidebarSeconds.querySelector(".submenu-opened") &&
        this.sidebarSeconds
          .querySelector(".submenu-opened")
          .classList.remove("submenu-opened"),
      document.body.classList.remove("show-overlay"),
      (this.sidebarSecondsFLAG = !1);
  }
  onMouseLeaveHandlerSecond() {
    this.sidebarThirds.classList.remove("opened"),
      this.sidebarThirds.querySelector(".submenu-opened") &&
        this.sidebarThirds
          .querySelector(".submenu-opened")
          .classList.remove("submenu-opened"),
      (this.sidebarThirdsFLAG = !1);
  }
  setSidebarHeight() {
    document
      .querySelectorAll(
        ".sidebar__cart, .sidebar__cart .cart, .sidebar__search, .collection__filters, .collection__filters .filters"
      )
      .forEach((e) => {
        e.style.height = window.innerHeight + "px";
      }),
      (document.querySelector(".sidebar__menus").style.height =
        window.innerHeight + "px"),
      document.querySelector(
        ".sidebar__search.predictive-search .sidebar__search-results"
      ) &&
        (document.querySelector(
          ".sidebar__search.predictive-search .sidebar__search-results"
        ).style.maxHeight = window.innerHeight - 170 + "px");
  }
}
customElements.define("main-sidebar", MainSidebar);
let overlay = document.createElement("span");
(overlay.className = "cart-overlay-background"),
  overlay.addEventListener("click", () => {
    document.querySelector("sidebar-drawer.opened").hide();
  }),
  document.body.append(overlay),
  (overlay = document.createElement("span")),
  (overlay.className = "sidebar-overlay-background"),
  overlay.addEventListener("click", () => {
    document.querySelector("sidebar-drawer.opened").hide();
  }),
  document.body.append(overlay);
class SidebarDrawer extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("[data-close]").addEventListener("click", () => {
        this.hide();
      }),
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          const e = document.querySelector("sidebar-drawer.opened");
          e && e.hide();
        }
      }),
      this.setAttribute("style", "");
  }
  show() {
    (this.opened = !0),
      this.classList.add("opened"),
      document.body.classList.add("overflow-hidden"),
      "sidebar" == this.dataset.overlay
        ? document
            .querySelector(".sidebar-overlay-background")
            .classList.add("show")
        : "cart" == this.dataset.overlay &&
          document
            .querySelector(".cart-overlay-background")
            .classList.add("show"),
      document
        .querySelectorAll(
          ".sidebar__cart, .sidebar__cart .cart, .sidebar__search, .collection__filters, .collection__filters .filters"
        )
        .forEach((e) => {
          e.style.height = window.innerHeight + "px";
        }),
      (document.querySelector(".sidebar__menus").style.height =
        window.innerHeight + "px"),
      document.querySelector(
        ".sidebar__search.predictive-search .sidebar__search-results"
      ) &&
        (document.querySelector(
          ".sidebar__search.predictive-search .sidebar__search-results"
        ).style.maxHeight = window.innerHeight - 170 + "px"),
      this._mountA11YHelper();
  }
  hide() {
    (this.opened = !1),
      this.classList.remove("opened"),
      document.body.classList.remove("overflow-hidden"),
      "sidebar" == this.dataset.overlay
        ? document
            .querySelector(".sidebar-overlay-background")
            .classList.remove("show")
        : "cart" == this.dataset.overlay &&
          document
            .querySelector(".cart-overlay-background")
            .classList.remove("show"),
      this._unmountA11YHelper();
  }
  _mountA11YHelper(e) {
    let s =
        e ||
        this.querySelectorAll(
          '[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover'
        ),
      t = s[0],
      r = s[s.length - 1];
    this.classList.contains("sidebar__cart") &&
      !this.querySelector(".cart__form").classList.contains("cart--empty") &&
      (r = s[s.length - 2]),
      (this.A11Y_TAB_EVENT = ((e, s, t) => {
        ("Tab" === t.key || t.keyCode === window.KEYCODES.TAB) &&
          (t.shiftKey
            ? document.activeElement === e && (s.focus(), t.preventDefault())
            : document.activeElement === s && (e.focus(), t.preventDefault()));
      }).bind(this, t, r)),
      this.addEventListener("keydown", this.A11Y_TAB_EVENT);
  }
  _unmountA11YHelper(e) {
    this.removeEventListener("keydown", this.A11Y_TAB_EVENT);
  }
}
customElements.define("sidebar-drawer", SidebarDrawer);
class ProductModel extends HTMLElement {
  constructor() {
    super(),
      Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
  }
  setupModelViewerUI(e) {
    if (e) return;
    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );
    const s = this.modelViewerUI.viewer;
    s.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
      s.closest(".css-slider-holder") &&
        s
          .closest(".css-slider-holder")
          .classList.add("css-slider--disable-dragging");
    }),
      s.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
        s.closest(".css-slider-holder") &&
          s
            .closest(".css-slider-holder")
            .classList.remove("css-slider--disable-dragging");
      }),
      s.closest(".product-gallery__item") &&
        "0" == s.closest(".product-gallery__item").dataset.index &&
        s.closest(".css-slider-holder") &&
        s
          .closest(".css-slider-holder")
          .classList.add("css-slider--disable-dragging");
  }
}
customElements.define("product-model", ProductModel),
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      e ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((e) => {
              window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  });
class ProductQuantity extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector(".quantity__selector"),
      e = this.querySelector(".quantity__minus"),
      s = this.querySelector(".quantity__plus"),
      a = t.getAttribute("min") ? parseInt(t.getAttribute("min")) : 1,
      i = t.getAttribute("max") ? parseInt(t.getAttribute("max")) : 999;
    parseInt(t.value) - 1 < a && e.classList.add("disabled"),
      parseInt(t.value) + 1 > i && s.classList.add("disabled"),
      e.addEventListener("click", (i) => {
        if ((i.preventDefault(), !e.classList.contains("disabled"))) {
          const i = parseInt(t.value);
          i - 1 >= a && ((t.value = i - 1), s.classList.remove("disabled")),
            i - 1 <= a && e.classList.add("disabled");
        }
      }),
      s.addEventListener("click", (a) => {
        if ((a.preventDefault(), !s.classList.contains("disabled"))) {
          const a = parseInt(t.value);
          a + 1 <= i && ((t.value = a + 1), e.classList.remove("disabled")),
            a + 1 >= i && s.classList.add("disabled");
        }
      });
  }
}
customElements.define("product-quantity", ProductQuantity);
class SharePopup extends HTMLElement {
  constructor() {
    super(),
      basicLightbox.create(this.querySelector("#share-popup"), {
        trigger: this.querySelector(".share-link"),
        focus: "a",
      });
  }
}
customElements.define("share-popup", SharePopup);
class CollectionFiltersMobileHandle extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("button").addEventListener("click", () => {
        document.querySelector(".collection__filters").show();
      });
  }
}
customElements.define(
  "collection-filters-mobile-handle",
  CollectionFiltersMobileHandle
);
class ProductDescription extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    (this.description = this.querySelector(".product__description")),
      this.description.classList.contains("truncated") &&
        ((this.descriptionInner = this.description.querySelector(
          ".product__description-inner"
        )),
        this.descriptionInner.offsetHeight - 10 >
          this.description.offsetHeight &&
          ((this.descriptionTrigger = document.createElement("a")),
          this.descriptionTrigger.classList.add("truncated__trigger"),
          this.descriptionTrigger.setAttribute("tabindex", "0"),
          this.descriptionTrigger.setAttribute(
            "aria-controls",
            this.descriptionInner.id
          ),
          this.descriptionTrigger.setAttribute("aria-expanded", !1),
          (this.descriptionTrigger.textContent =
            KROWN.settings.locales.product_more_description_label),
          this.description.after(this.descriptionTrigger),
          this.descriptionTrigger.addEventListener(
            "click",
            this.onClickHandler.bind(this)
          ),
          this.descriptionTrigger.addEventListener("keydown", (e) => {
            e.keyCode == window.KEYCODES.RETURN && this.onClickHandler(e);
          })));
  }
  onClickHandler(e) {
    e.preventDefault(),
      this.description.classList.contains("truncated--show")
        ? (this.description.classList.remove("truncated--show"),
          this.description.setAttribute("style", ""),
          (this.descriptionTrigger.textContent =
            KROWN.settings.locales.product_more_description_label),
          this.descriptionTrigger.setAttribute("aria-expanded", !1))
        : (this.description.classList.add("truncated--show"),
          (this.description.style.maxHeight =
            this.descriptionInner.offsetHeight + "px"),
          (this.descriptionTrigger.textContent =
            KROWN.settings.locales.product_less_description_label),
          this.descriptionTrigger.setAttribute("aria-expanded", !0),
          this.descriptionInner.setAttribute("tabIndex", "0"));
  }
}
customElements.define("product-description", ProductDescription),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.classList.contains("main-product") &&
      e.target.querySelector("product-description") &&
      e.target.querySelector("product-description").init();
  });
class ProductPage extends HTMLElement {
  constructor() {
    super(),
      (this.productGallery = this.querySelector(".product-gallery")),
      (this.productSlider = this.querySelector("css-slider")),
      this.querySelector(".product-gallery__thumbnails .thumbnail") &&
        (this.querySelectorAll(
          ".product-gallery__thumbnails .thumbnail"
        ).forEach((e, t) => {
          0 == t && e.classList.add("active"),
            e.addEventListener("click", (e) => {
              this.productSlider.sliderEnabled
                ? this.productSlider.changeSlide(e.currentTarget.dataset.index)
                : (window.scrollTo({
                    top:
                      this.productGallery.querySelector(
                        `.product-gallery__item[data-index="${e.currentTarget.dataset.index}"]`
                      ).offsetTop + this.offsetTop,
                    behavior: "smooth",
                  }),
                  this.thumbnailNavigationHelper(
                    e.currentTarget.dataset.index
                  )),
                pauseAllMedia(),
                playMedia(
                  this.productGallery.querySelector(
                    `.product-gallery__item[data-index="${e.currentTarget.dataset.index}"]`
                  )
                );
            });
        }),
        this.productSlider.addEventListener("change", (e) => {
          this.thumbnailNavigationHelper(e.target.index);
        })),
      this.productSlider.addEventListener("navigation", (e) => {
        playMedia(
          this.productGallery.querySelector(
            `.product-gallery__item[data-index="${e.target.index}"]`
          )
        );
      }),
      this.productSlider.addEventListener("change", (e) => {
        "model" ==
          this.productGallery.querySelector(
            `.product-gallery__item[data-index="${e.target.index}"]`
          ).dataset.productMediaType &&
          this.xrButton &&
          this.xrButton.setAttribute(
            "data-shopify-model3d-id",
            this.productGallery.querySelector(
              `.product-gallery__item[data-index="${e.target.index}"]`
            ).dataset.mediaId
          ),
          pauseAllMedia(),
          this.thumbnailNavigationHelper(e.target.index);
      });
    const e = this.querySelector("product-variants");
    if (
      (e &&
        (e.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this)
        ),
        this.onVariantChangeHandler({ target: e })),
      !document.body.classList.contains("template-cart") &&
        "overlay" == KROWN.settings.cart_action)
    ) {
      let e = !1;
      this.querySelector(".product__add-to-cart") &&
        this.querySelector(".product__add-to-cart").addEventListener(
          "keyup",
          (t) => {
            t.keyCode == window.KEYCODES.RETURN && (e = !0);
          }
        ),
        this.querySelector(".product__form") &&
          this.querySelector(".product__form").addEventListener(
            "add-to-cart",
            () => {
              window.preloadImages(document.querySelector(".sidebar__cart")),
                document.querySelector(".sidebar__cart").show(),
                e &&
                  setTimeout(() => {
                    document
                      .querySelector(".sidebar__cart .sidebar__cart-close")
                      .focus();
                  }, 200);
            }
          );
    }
    if (
      ((this.GALLERY_RESIZE_EVENT = debounce(() => {
        ProductGalleryResizeHelper(this.productGallery);
      }, 100)),
      window.addEventListener("resize", this.GALLERY_RESIZE_EVENT, {
        passive: !0,
      }),
      this.productGallery.classList.contains("product-gallery--scroll"))
    ) {
      (this.productGalleryNavigation = this.querySelector(
        ".product-gallery__thumbnails"
      )),
        (this.productGalleryNavigationItem = this.querySelectorAll(
          ".product-gallery__thumbnails .thumbnail"
        ));
      const e = [
        ...this.productGallery.querySelectorAll(".product-gallery__item"),
      ].reverse();
      (this.GALLERY_NAVIGATION_SCROLL = () => {
        if (
          !this.productGallery.querySelector("css-slider").sliderEnabled &&
          window.innerWidth > 1023
        ) {
          for (const t of e) {
            const e = t.getBoundingClientRect().top;
            if (e < window.innerHeight / 2 && e > -window.innerHeight / 2) {
              this.productGalleryNavigationItem.forEach((e) =>
                e.classList.remove("active")
              ),
                this.productGalleryNavigationItem[
                  t.dataset.index
                ].classList.add("active");
              break;
            }
          }
          const t = this.productGallery.getBoundingClientRect().top;
          -1 * (t - window.innerHeight) > this.productGallery.offsetHeight
            ? this.productGalleryNavigation.classList.add("scroll")
            : t > 0
            ? (this.productGalleryNavigation.classList.add("scroll-up"),
              this.productGalleryNavigation.classList.add("scroll"))
            : -1 * (t - window.innerHeight) <
                this.productGallery.offsetHeight &&
              (this.productGalleryNavigation.classList.remove("scroll"),
              this.productGalleryNavigation.classList.remove("scroll-up"));
        }
      }),
        window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, {
          passive: !0,
        }),
        this.GALLERY_NAVIGATION_SCROLL();
    }
    this.querySelectorAll("product-model") &&
      (window.ProductModel.loadShopifyXR(),
      (this.xrButton = this.querySelector(".product-gallery__view-in-space")));
    const t = this.querySelector(".product__add-to-cart");
    if (t) {
      t.classList.contains("disabled")
        ? this.querySelector("product-form").classList.add("disable-buy-button")
        : this.querySelector("product-form").classList.remove(
            "disable-buy-button"
          );
      new MutationObserver((e) => {
        for (const r of e)
          t.classList.contains("disabled")
            ? this.querySelector("product-form").classList.add(
                "disable-buy-button"
              )
            : this.querySelector("product-form").classList.remove(
                "disable-buy-button"
              );
      }).observe(t, { attributes: !0, childList: !1, subtree: !1 });
    }
  }
  thumbnailNavigationHelper(e = 0) {
    this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(
      (t, r) => {
        r == e ? t.classList.add("active") : t.classList.remove("active");
      }
    );
  }
  onVariantChangeHandler(e) {
    let t = e.target.currentVariant;
    if (t && null != t.featured_media) {
      let e = this.productGallery.querySelector(
        '.product-gallery__item[data-media-id="' + t.featured_media.id + '"]'
      );
      e &&
        (this.productGallery.classList.contains("product-gallery--slider") ||
        (this.productGallery.classList.contains("product-gallery--scroll") &&
          window.innerWidth < 1024)
          ? this.productGallery.querySelector("css-slider").sliderEnabled &&
            this.productGallery
              .querySelector("css-slider")
              .changeSlide(e.dataset.index)
          : window.scrollTo({ top: e.offsetTop, behavior: "smooth" }));
    }
  }
}
customElements.define("product-page", ProductPage);
class ProductReviews {
  constructor(e) {
    const t = new MutationObserver((e, t) => {
      for (const r of e)
        r.addedNodes.length > 0 &&
          r.addedNodes.forEach((e) => {
            "DIV" == e.tagName &&
              e.classList.contains("spr-container") &&
              (this.init(e), t.disconnect());
          });
    });
    e.querySelector(".spr-review")
      ? this.init(e.querySelector(".spr-container"))
      : t.observe(e, { childList: !0 });
  }
  init(e) {
    if (e.querySelector(".spr-review")) {
      const t = e.querySelector(".spr-reviews"),
        r = document.createElement("div");
      (r.innerHTML = `<css-slider\n\t      class="spr-reviews css-slider--simple-dots" \n\t      data-options='{\n\t        "selector": ".spr-review",\n\t        "navigation": false,\n\t        "groupCells": true,\n\t        "autoHeight": ${
        window.innerWidth < 520
      }\n\t      }'>${t.innerHTML}</div>`),
        t.remove(),
        e.querySelector(".spr-content").append(r);
      const i = r.querySelector("css-slider");
      setTimeout(() => {
        i.resetSlider(!0);
      }, 100);
      const s = new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            if (
              e.isIntersecting &&
              e.target.querySelector(".spr-pagination-next a")
            ) {
              const t = e.target.querySelector(".spr-pagination-next a");
              getJSONP(
                `${SPR.api_url}/reviews?page=${t.dataset.page}&product_id=${t.dataset.productId}&shop=${window.location.hostname}&callback=?`,
                (e) => {
                  t.closest(".spr-pagination").remove();
                  const r = new DOMParser().parseFromString(
                    e.reviews,
                    "text/html"
                  );
                  r.querySelectorAll(".spr-review, .spr-pagination") &&
                    r
                      .querySelectorAll(".spr-review, .spr-pagination")
                      .forEach((e) => {
                        i.querySelector(".css-slider-container").append(e),
                          e.classList.contains("spr-pagination") &&
                            (s.disconnect(), s.observe(e));
                      }),
                    i.afterAppend(),
                    i.resetSlider(!0, !1);
                }
              );
            }
          });
        },
        { threshold: 1 }
      );
      r.querySelector(".spr-pagination") &&
        s.observe(r.querySelector(".spr-pagination"));
    }
    const t = document.createElement("div");
    (t.id = "spr-form-modal"),
      (t.innerHTML =
        '<div id="spr-form" class="spr-form-holder address-popup">\n      <div class="basicLightboxClose" tabindex="0">×</div>\n    </div>'),
      document
        .querySelector(".spr-summary-actions-newreview")
        .setAttribute("onclick", "");
    const r = basicLightbox.create(t, {
      trigger: document.querySelector(".spr-summary-actions-newreview"),
      focus: 'input[type="text"]',
    });
    r
      .element()
      .querySelector(".spr-form-holder")
      .prepend(e.querySelector(".spr-form")),
      (r.element().querySelector(".spr-form").style.display = "block");
  }
}
document.getElementById("shopify-product-reviews") &&
  new ProductReviews(document.getElementById("shopify-product-reviews")),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.classList.contains("mount-product-gallery") &&
      ProductGalleryResizeHelper(e.target.querySelector(".product-gallery"));
  });
class GalleryZoom extends HTMLElement {
  constructor() {
    super();
    const e = basicLightbox.create(
      `<img data-src="${this.dataset.src}" alt="" />`
    );
    this.addEventListener("click", (t) => {
      t.preventDefault();
      const s = e.element().querySelector("img");
      s.setAttribute("src", s.dataset.src), e.show();
    });
  }
}
customElements.define("gallery-zoom", GalleryZoom);
class ImageSlideshow extends CSSSlider {
  constructor() {
    if (
      (super(),
      (this.slides = this.querySelectorAll(".slide")),
      (this.images = this.querySelectorAll("img")),
      (this.overlays = this.querySelectorAll(".slide__overlay")),
      (this.texts = this.querySelectorAll(".slide__text")),
      this.classList.contains("slider--scroll"))
    ) {
      const s = document.createElement("div");
      s.classList.add("slider__dots"),
        this.append(s),
        this.images.forEach((t, i) => {
          const e = document.createElement("div");
          e.classList.add("dot"),
            s.append(e),
            e.addEventListener("click", () => {
              window.scrollTo({
                top: this.slides[i].offsetTop,
                behavior: "smooth",
              });
            }),
            0 == i && e.classList.add("active");
        }),
        (this.sliderDot = this.querySelectorAll(".slider__dots .dot")),
        (this.sliderDots = this.querySelector(".slider__dots")),
        (this.onScrollHandler = (() => {
          var s = this.offsetTop,
            t = window.scrollY,
            i = window.innerHeight;
          t >= s && t + i <= s + this.offsetHeight
            ? this.images.forEach((e, l) => {
                const o = (t - s - i * l) / 2;
                Math.abs(o) <= i / 2 &&
                  this.scrollTransform(
                    o,
                    this.images[l],
                    this.overlays[l],
                    this.texts[l]
                  ),
                  t >= i * l + s - i / 2 &&
                    !this.sliderDot[l].classList.contains("active") &&
                    (this.sliderDots
                      .querySelector(".active")
                      .classList.remove("active"),
                    this.sliderDot[l].classList.add("active"));
              })
            : t < s
            ? this.scrollTransform(
                0,
                this.images[0],
                this.overlays[0],
                this.texts[0]
              )
            : t + i > s + this.offsetHeight &&
              this.scrollTransform(
                0,
                this.images[this.images.length - 1],
                this.overlays[this.overlays.length - 1],
                this.texts[this.texts.length - 1]
              ),
            this.sliderDots.classList.contains("in-view") &&
            (t + i > s + this.offsetHeight || t < s)
              ? (this.sliderDots.classList.remove("in-view"),
                t < s
                  ? this.sliderDots.classList.remove("in-bottom")
                  : t + i > s && this.sliderDots.classList.add("in-bottom"))
              : !this.sliderDots.classList.contains("in-view") &&
                t >= s &&
                t + i <= s + this.offsetHeight &&
                this.sliderDots.classList.add("in-view");
        }).bind(this)),
        window.addEventListener("scroll", this.onScrollHandler, {
          passive: !0,
        }),
        this.onScrollHandler(),
        this.addEventListener("ready", () => {
          this.images.forEach((s, t) => {
            this.scrollTransform(
              0,
              this.images[t],
              this.overlays[t],
              this.texts[t],
              !0
            );
          });
        });
    }
    (this.onResizeHandler = (() => {
      this.classList.contains("slider--scroll") && this.onScrollHandler(),
        window.innerWidth < 948 &&
          this.classList.contains("slider--mobile-js-height") &&
          (this.classList.contains("slider--horizontal") ||
            this.classList.contains("slider--horizontal-mobile-true")) &&
          (this.style.height =
            document.documentElement.clientHeight -
            this.dataset.navigationPadding +
            "px");
    }).bind(this)),
      this.onResizeHandler(),
      (this.classList.contains("slider--horizontal") ||
        this.classList.contains("slider--horizontal-mobile-true")) &&
        ("scrollBehavior" in document.documentElement.style ||
          document.body.classList.contains("touch")) &&
        this.addEventListener("scroll", () => {
          const s = -this.element.scrollLeft;
          this.slides.forEach((t, i) => {
            const e = this.images[i];
            if (e) {
              const l = t.offsetLeft;
              (e.style.transform = `translateX(${(-1 * (l + s)) / 3}px)`),
                (this.texts[i].style.transform = `translateX${(l + s) / 8}px)`),
                (this.overlays[i].style.opacity =
                  "" + (-1 * (l + s)) / 10 / 100);
            }
          });
        });
  }
  scrollTransform(s, t, i, e, l = !1) {
    t &&
      (l ||
        (document.body.classList.contains("no-touch") &&
          window.innerWidth > 948)) &&
      ((t.style.transform = `translate3d(0, ${s}px, 0)`),
      s >= 0 && (i.style.opacity = "" + s / (window.innerHeight / 2)),
      (e.style.transform = `translate3d(0, ${s / 10}px, 0)`));
  }
}
customElements.define("image-slideshow", ImageSlideshow);
(KROWN.themeName = "Kingdom"),
  (KROWN.themeVersion = "4.3.1"),
  document.addEventListener("shopify:section:load", (e) => {
    window.reorderSections(), window.preloadImages(e.target);
  }),
  document.addEventListener("shopify:section:unload", (e) => {
    window.reorderSections(), window.preloadImages(e.target);
  }),
  document.addEventListener("shopify:section:reoder", (e) => {
    window.reorderSections(), window.preloadImages(e.target);
  });
const executeOnceOnDomContentLoaded = () => {
  reframe(
    document.querySelectorAll(
      '.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]'
    )
  ),
    document.querySelectorAll("input").forEach((e) => {
      e.addEventListener("change", (e) => {
        "" != e.target.value
          ? e.target.classList.add("filled")
          : e.target.classList.remove("filled");
      });
    }),
    document.querySelectorAll('input[type="search"]').forEach((e) => {
      e.value = "";
    });
  let e = document.activeElement;
  document.addEventListener("keyup", (t) => {
    t.keyCode == window.KEYCODES.TAB &&
      (e.classList.contains("focus") &&
        t.target != e &&
        e.classList.remove("focus"),
      (t.target.classList.contains("regular-select-cover") ||
        t.target.classList.contains("search-field") ||
        t.target.classList.contains("product-item__link") ||
        t.target.classList.contains("content-slider") ||
        t.target.classList.contains("blog-item__header") ||
        t.target.classList.contains("toggle__title") ||
        "INPUT" == t.target.tagName) &&
        ((e = t.target), t.target.classList.add("focus")));
  }),
    "?customer_posted=true" == window.location.search
      ? setTimeout(() => {
          window.scroll({
            top: document.querySelector("form .alert").offsetTop - 250,
            behavior: "smooth",
          });
        }, 300)
      : window.location.pathname.includes("/challenge") &&
        setTimeout(() => {
          window.scroll({ top: 0, behavior: "auto" });
        }, 300);
};
"loading" !== document.readyState
  ? executeOnceOnDomContentLoaded()
  : document.addEventListener(
      "DOMContentLoaded",
      executeOnceOnDomContentLoaded
    );
